import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../_service/common.service';
import { appConfig, baseUrl } from '../app.config';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Observable, of, Subject } from "rxjs";
import { PagerService } from '../_service/pager-service';
import { NotificationService } from '../_service/notification.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CountryService } from '../_service/country.service';
import { SitesService } from '../_service/sites.service';
import { SupplierService } from '../_service/supplier.service';
import { purchasingApiService } from '../_service/purchasing.service';
import { AddressService } from '../_service/address.service';

const TWO = 2;
const THREE = 3;
const FOUR = 4;
const FIVE = 5;
const SIX = 6;
const SEVEN = 7;
const EIGHT = 8;
const NINE = 9;
const TEN = 10;
const TWENTY = 20;
const TWENTY_FIVE = 25;
const THIRTY_FIVE = 35;
const SIXTY = 60;
const ONE_HUNDRED_SEVEN = 107;
const KEY_ENTER = 13;
const SHORT_DELAY_MS = 1000;
const MEDIUM_DELAY_MS = 2000;
const STEP_DELAY_MS = 3000;
const SEARCH_ERROR_NOTIFICATION_MS = 90000;
const CONFIDENCE_A_THRESHOLD = 0.95;
const CONFIDENCE_B_MIN = 0.85;
const CONFIDENCE_B_MAX = 0.94;
const CONFIDENCE_C_MIN = 0.75;
const CONFIDENCE_C_MAX = 0.84;
const CONFIDENCE_D_MIN = 0.60;
const CONFIDENCE_D_MAX = 0.74;

@Component({
    selector: 'app-bvd',
    templateUrl: './bvd.component.html',
    styleUrls: ['./bvd.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatOptionModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        NgxPaginationModule,
        NgSelectModule
    ]
})
export class BvdComponent implements OnInit {
  private static readonly DEBOUNCE_MS = 400;
  private static readonly COMMODITY_DEBOUNCE_MS = 500;
  private static readonly COUNTRY_PAGE_SIZE = 50;
  private static readonly CITY_PAGE_SIZE = 20;
  private static readonly PAGE_HEIGHT_ROW_FACTOR = 30;
  private static readonly PAGE_HEIGHT_BASE_OFFSET = 300;
  private static readonly PAGE_HEIGHT_FALLBACK = 550;

  Config: any;
  public maxRecorePage = TWENTY;
  data: any = [];
  loadData: boolean = false;
  loading: boolean = false;
  loadingImpsupp: boolean = false;
  public PageTotalLength: any = "";
  pager: any = {};

  delayResCountry = new UntypedFormControl();
  delayResCountryDuo = new UntypedFormControl();
  delayResCity = new Subject<string>();
  public CaptCountry: any = [];
  public CountryNameKeyId: any = [];
  public selectedCountry: any = "failed";
  public CaptCity: any = [];
  public CityNameKeyId: any = [];
  public selectedCity: any = "failed";
  public CaptCountryForTaxId: any = [];
  public siteCountryModelForTaxId = '';

  Qualifiers: {
    "P14": "assets/sites/icons/P14.png",
    "P18": "assets/sites/icons/P18.png",
  }
  companyNameModel: any = ""
  public siteCountryModel: any = "";
  public siteCityModel: any = "";
  companyNameModelError: boolean = false;
  public siteCountryModelError: boolean = false;
  cityDisable: boolean = true;
  importNextButt: any = "Next";
  radioImpSupplier: boolean = true;
  BvDnumber: any;
  BvDbySplitNumber: any;
  BvDdata: any = [];
  importSuppStep2: boolean = false;
  importSuppStep3: boolean = false;
  addStep2Check: boolean = false;
  public groupCategories: any = [];
  groupCategoriesByKey: any = [];
  public groupCategoryModel: any = '';
  public groupCategoryModelError: boolean = false;
  public groupCommodityCodeModelLabel = '';
  public groupNameModelError: boolean = false;
  public groupMdmSwitch: boolean = false;
  userQuestionUpdate3 = new Subject<string>();
  tempvar: any = '';
  public commoditycodeloaded: boolean = false;
  public commoditycodeloadedcheck: boolean = true;
  public commoditycodevalueSelected: boolean = false;
  public commodityCodes: any = [];
  public commodityCodeids: any = [];
  commodityCodeScopeRowid: any = '';
  arrCommoditycodes: boolean = false;
  public supplierCommodityCodes: any = [];
  public groupCommodityCodeModel: any = '';
  public groupCommodityCodeModelError: boolean = false;
  GroupBvDdetails: any = [];
  GroupSelectDisab: boolean = false;
  typeName = 'bop';
  public companyStatusRowid: any = '';
  public companyRowId: any = '';
  public mainTaxRowid: any = '';
  public IdenKeywithId: any = [];
  public CIdentifierTypes: any = [];
  companyInfos: any = [];
  companyList: any = [];

  sveCompanies: any = "";

  SitesInfo: any = [];
  SiteRowID: any = "";
  Site_hrefTo_Cid: any = [];
  beRowID: any = [];
  site_qualifiers: any = [];
  SiteDispLoading: boolean = true;
  SiteDe_BvdID_Stat: any = [];
  Site_City_Country: any = [];

  public cpyAlcorToRaft = [];
  public cpyRowIdHolder = '';
  public siteCity: any = '';
  public arrBasedOnVal = [];
  public sitesData = [];
  public qualifierChangetoPending = ['P11', 'P05', 'P06', 'P19', 'P07', 'P09', 'P08'];

  public qualifierTypesText = {
    P05: "Manufacturing",
    P06: "Invoicing",
    P07: "Picking",
    P08: "Customer",
    P09: "Quality Return",
    P11: "Ordering",
    P14: "Main Entrance",
    P18: "Headquarters",
    P19: "Supply Chain EDI"
  };

  public sortedQualifiers = {
    "P14": "assets/sites/icons/P14.png",
    "P18": "assets/sites/icons/P18.png",
    "P11": "assets/sites/icons/P11.png",
    "P05": "assets/sites/icons/P05.png",
    "P19": "assets/sites/icons/P19.png",
    "P07": "assets/sites/icons/P07.png",
    "P09": "assets/sites/icons/P09.png",
    "P06": "assets/sites/icons/P06.png",
    "P08": "assets/sites/icons/P08.png",
    "P100": ""
  };

  public groupNameModel = '';
  saveDatas: any = "Save";
  public alphabetsArray = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  public digitsArray = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  public envHide: any = "";
  BE_Check: boolean = false;
  ImportDone: boolean = false;
  DisableSearch: boolean = false;
  NL_BVD_ID_NUMBER: any = "";
  NL_HQ_BVD_ID_NUMBER: any = "";
  NL_GUO_BVD_ID_NUMBER: any = "";
  NL_SaveGrp_ID: any = "";
  NL_Case_Occur: any = "";
  public newCategoryAssignment = '6';
  public newCategoryName = 'SUPPLIER SITE'
  loadingImpsupp2: boolean = false;
  loadCompanySection: boolean = false;

  guoBvdCheck: boolean = false;
  hqBvdCheck: boolean = false;
  europeanVatNums: any = [];
  checkEVatNumerrorCount: number = 0;
  checkForStopOrContinue: boolean = false;

  public groupShortNameError = false;
  public groupShortNameRegExError = false;
  public groupShortNameExistsError = false;
  public groupShortName: any = '';
  GroupAssign: any;
  public accessPointIdenRowIds = [];
  NL_BvDdataCnS: any = [];
  NL_GUO_BvDdata: any = [];
  BEIDval: any = [];

  NL_flagGroup: boolean = false;
  NL_flagCompany: boolean = false;
  NL_flagSite: boolean = false;
  loadingImpsupp3: boolean = false;
  loadSiteSection: boolean = false;

  NL_flagGroup_step1Init: boolean = false;
  NL_flagCompany_step2Init: boolean = false;
  NL_flagSite_step3Init: boolean = false;
  IdentifierModel: any = '';
  selectedCustomCountry = '';
  countrySelList = [];
  tempVarCounList = {};
  varIsMergingSite = '2';
  disableGrpShortNameLoad: boolean;
  groupIdHolder = '';
  selectedIdentifierType = '';
  public superUserShow = false;
  public selectedIdentifierError = false;
  roleVariableHide: boolean;
  showCountrySelectForTaxId: boolean = false;
  siteCountryModelErrorForIdens: boolean;
  disableIdentifierInput: boolean = true;
  countryCityList: any = [];
  latestCompanyId = '';
  groupCurrentStatus = 'loading...';
  roleIsManager: boolean;
  showBuyerProfile: boolean;
  disableNext: boolean = true;
  nextBtnNotVisible: boolean = false;
  pageHeight: number = 0;
  public dataForDispCountryInfo = [];
  countryInfoLoading = false;
  TaxIdentifierKeys: any[] = [];
  companyAliasAll: any = [];
  companyIdenKeys: any = [];
  public businessEntityIdSite = '';
  NullCheck: boolean = false;
  countryLoad1: boolean;
  countryLoad2: boolean;
  companyAllianceIdentifier: any;
  grpDisp: boolean = false;
  CompanySelectDisab: boolean = true;
  c2bName: any = '';
  c2bValue: boolean = true;
  accessPointDatas3: any
  accessPointDatas1: any
  displayC2b: boolean;
  nodisplay: boolean = true;
  C2bDisplay: boolean = true;
  c2bError: boolean;
  loadingC2b: boolean;
  cmpDetails = [];
  cmpShortName: any = '';
  siteDisableNext: boolean = true;
  baseUrl2 = baseUrl;
  key: string = 'name';
  reverse: boolean = false;
  currentOrbisStatus: any;
  noreload: boolean = false;
  BvdtoImport: any;
  bvdSearch: boolean;
  createdSiteBvdIds: Set<string> = new Set();

  constructor(private apiService: CommonService, private addressService: AddressService, private purchasingService: purchasingApiService, private countryService: CountryService, private siteService: SitesService, private supplierService: SupplierService, private pagerService: PagerService, private notificationService: NotificationService, private http: HttpClient, private router: Router, private renderer: Renderer2, private cdr: ChangeDetectorRef) {
    this.Config = appConfig;
    this.userQuestionUpdate3.pipe(debounceTime(BvdComponent.COMMODITY_DEBOUNCE_MS), distinctUntilChanged()).subscribe(value => {
      if (this.commoditycodeloadedcheck == true) {
        this.getCommodityCodes(value);
      } else {
        this.commoditycodeloadedcheck = true;
      }
    });
  }

  ngOnInit() {
    this.envHide = this.apiService.getEnv();
    if (this.envHide == false) {
    }

    this.delayResCountry.valueChanges.pipe(debounceTime(BvdComponent.DEBOUNCE_MS), distinctUntilChanged()).subscribe(sat => {
      this.siteCountryModel = sat
      this.getCountriesList(this.siteCountryModel);
    });
    this.delayResCountryDuo.valueChanges.pipe(debounceTime(BvdComponent.DEBOUNCE_MS), distinctUntilChanged()).subscribe(sat => {
      this.siteCountryModelForTaxId = sat
      this.getCountriesListDuo(this.siteCountryModelForTaxId);
    });
    this.delayResCity.pipe(debounceTime(BvdComponent.DEBOUNCE_MS), distinctUntilChanged()).subscribe(_sat => {
      this.getCityList(this.siteCityModel);
    });
    this.getRoles();
  }

  getRoles() {
    var RoleByService = this.apiService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  copyToClipboard(text: string) {
    this.apiService.copyToClipboard(text)
  }
  checkAllProfilesAndEnv(RoleByService) {
    let c = RoleByService;
    if (c['superAdmin'] == 'yes') {
      this.superUserShow = true;
    } else {
      this.superUserShow = false;
    }
    if (c['role'] == 'admin' || c['role'].includes('admin')) {
      this.roleVariableHide = true;
    } else {
      this.roleVariableHide = false;
    }
    if (c['role'] == 'manager') {
      this.roleIsManager = true;
    } else {
      this.roleIsManager = false;
    }
    if (c['buyer'] == 'yes') {
      this.showBuyerProfile = false;
    } else {
      this.showBuyerProfile = true;
    }
  }

  ValidateMandarotyFields() {
    if (this.companyNameModel.trim() != "" && this.siteCountryModel.trim() != "") {
      this.companyNameModelError = false;
      this.siteCountryModelError = false;
      this.siteCountryModelErrorForIdens = false;
      this.getSearch();
    } else if (this.IdentifierModel.trim() != '' && this.IdentifierModel.trim().length > TWO && this.selectedIdentifierType == 'bvdid') {
      this.selectedIdentifierError = false;
      this.siteCountryModelErrorForIdens = false;
      this.getSearch();
    } else if (this.IdentifierModel.trim() != '' && this.IdentifierModel.trim().length > TWO && this.selectedIdentifierType == 'taxid' && this.siteCountryModelForTaxId != '') {
      this.selectedIdentifierError = false;
      this.siteCountryModelErrorForIdens = false;
      this.getSearch();
    } else {
      if (this.selectedIdentifierType == '' && this.IdentifierModel.trim() != '') {
        this.selectedIdentifierError = true;
      } else if (this.selectedIdentifierType == 'taxid' && this.IdentifierModel.trim() != '' && this.siteCountryModel == '') {
        this.siteCountryModelErrorForIdens = true;
      } else {
        this.siteCountryModelErrorForIdens = false;
        this.selectedIdentifierError = false;
        if (this.companyNameModel.trim() == "") {
          this.companyNameModelError = true;
        } else {
          this.companyNameModelError = false;
        }

        if (this.siteCountryModel.trim() == "" || this.siteCountryModel.length <= TWO) {
          this.siteCountryModelError = true;
        } else {
          this.siteCountryModelError = false;
        }
      }
    }
  }

  private getAllCountryPages(searchQuery: string, page = 1, maxPage = 1, countries: any[] = []): Observable<any[]> {
    return this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?${searchQuery}&_page=${page}&_pagesize=${BvdComponent.COUNTRY_PAGE_SIZE}`).pipe(
      switchMap((data: any) => {
        const mergedCountries = countries.concat(data['countries'] || []);
        const responseMaxPage = Number(data['maxPage'] ?? maxPage);

        if (page < responseMaxPage) {
          return this.getAllCountryPages(searchQuery, page + 1, responseMaxPage, mergedCountries);
        }

        return of(mergedCountries);
      })
    );
  }

  getCountriesList(event: any) {
    const countrySearchText = (event || '').trim();
    if (/^[A-Z]{2} - .+/i.test(countrySearchText)) {
      this.countryLoad1 = false;
      return;
    }
    if (countrySearchText.length != 0) {
      this.nodisplay = true
      this.countryLoad1 = true
      const searchQuery = countrySearchText.length <= TWO ? `countryCode=${countrySearchText}` : `countryName=*${countrySearchText}*`;
      this.getAllCountryPages(searchQuery).subscribe((countries: any[]) => {
        this.CountryNameKeyId = [];
        this.CaptCountry = [];
        this.countryCityList = [];
        countries.forEach(element => {
          let captain_exist = this.CaptCountry.indexOf(element.countryName);
          if (captain_exist == -1) {
            this.CaptCountry.push(`${element.countryCode.toUpperCase()} - ${element.countryName}`);
            this.CountryNameKeyId[element.countryCode] = element;
            this.countryCityList[element.countryName] = element.countryCode;
          }
        });
        this.countryLoad1 = false;
      });
    }
  }

  getCountriesListDuo(event: any) {
    const countrySearchText = (event || '').trim();
    if (/^[A-Z]{2} - .+/i.test(countrySearchText)) {
      this.countryLoad2 = false;
      return;
    }
    if (countrySearchText.length != 0) {
      this.countryLoad2 = true
      const searchQuery = countrySearchText.length <= TWO ? `countryCode=${countrySearchText}` : `countryName=*${countrySearchText}*`;
      this.getAllCountryPages(searchQuery).subscribe((countries: any[]) => {
        this.CountryNameKeyId = [];
        this.CaptCountryForTaxId = [];
        countries.forEach(element => {
          let captain_exist = this.CaptCountryForTaxId.indexOf(element.countryName);
          if (captain_exist == -1) {
            this.CaptCountryForTaxId.push(`${element.countryCode.toUpperCase()} - ${element.countryName}`);
            this.CountryNameKeyId[element.countryCode] = element;
          }
        });
        this.countryLoad2 = false;
      });
    }
  }

  getCityList(event: any, CName = "", countryCode = '') {
    console.info('getting city list....', event, '-', CName, '-', countryCode, '-', 'selectedCountry', '-', this.selectedCountry);
    console.info('country list', this.CountryNameKeyId);
    if (this.selectedCountry != "failed" && event.length >= TWO) {
      var NCityName = "";
      if (CName == "") {
        NCityName = this.siteCityModel;
      } else {
        NCityName = CName;
      }
      let NcountryCode = '';
      let split = this.siteCountryModel.split(" - ");
      if (countryCode == '') {
        NcountryCode = split[1];
      } else {
        NcountryCode = countryCode;
      }
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${this.CountryNameKeyId[NcountryCode].countryCode}&name=${NCityName}&_page=1&_pagesize=${BvdComponent.CITY_PAGE_SIZE}`).subscribe((data: any) => {
        if (data['count'] > 0) {
          this.CityNameKeyId = "";
          this.CityNameKeyId = [];
          this.CaptCity = "";
          this.CaptCity = [];
          data['cities'].forEach(element => {
            this.CaptCity.push(element.name);
            this.CityNameKeyId[element.name] = element;
          });
        } else {
          this.CaptCity = [];
        }
      });
    } else {
      this.CaptCity = [];
    }
  }

  onCountryeSelect(selected) {
    this.nodisplay = false
    if (selected) {
      this.selectedCountry = selected
      this.siteCountryModelError = false;
      this.siteCityModel = "";
      this.cityDisable = false;
    } else {
      this.selectedCountry = "failed";
      this.siteCountryModelError = true;
      this.siteCityModel = "";
      this.cityDisable = true;
    }
  }

  onCountryeSelectDuo(selected) {
    if (selected) {
      this.disableIdentifierInput = false;
      this.selectedCountry = selected
      this.siteCountryModelError = false;
    } else {
      this.selectedCountry = "failed";
      this.siteCountryModelError = true;
    }
  }

  onCityeSelect(selected) {
    if (selected) {
      this.selectedCity = selected
    } else {
      this.selectedCity = "failed";
    }
  }

  BvDFilter(_event: any, _from = "", _valueFromusr: any, page = 1, _byClick = "No") {
    this.getSearch(page)
  }

  c2bCheck() {
    this.c2bValue = !this.c2bValue
    if (this.c2bValue == true) {
      this.disableNext = true
    } else {
      this.disableNext = false;
      this.c2bName = ''
    }
  }

  checkvalidatec2b(event) {
    this.c2bName = event.toUpperCase();
    let valueLength = this.c2bName.length
    if (valueLength >= FOUR && valueLength <= TEN) {
      const regex = /^[A-Z]{3}[0-9]{1,7}$/;
      if (regex.test(this.c2bName)) {
        if (this.c2bName.slice(0, THREE) == 'SUP') {
          this.loadingC2b = true
          this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_C2B_CODE&identifierValue=${this.c2bName}`).subscribe(data => {
            if (data['access-point-identifiers'].length > 0) {
              this.loadingC2b = false
              this.c2bError = true
              this.disableNext = true
            } else {
              this.c2bError = false
              this.disableNext = false
              this.loadingC2b = false
            }
          })
        } else {
          this.disableNext = true
        }
      } else {
        this.disableNext = true
      }
    } else {
      this.disableNext = true
      this.c2bError = false
    }
  }

  private getAllBvdSearchPages(datas: any, page = 1, maxPage = 1, results: any[] = []): Observable<any> {
    const pageData = { ...datas, _page: page };
    return this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, pageData).pipe(
      switchMap((response: any) => {
        const responseData = JSON.parse(response.result);
        const mergedResults = results.concat(responseData['Data'] || []);
        const responseMaxPage = Number(responseData['maxPage'] ?? responseData['SearchSummary']?.['maxPage'] ?? maxPage);

        if (page < responseMaxPage) {
          return this.getAllBvdSearchPages(datas, page + 1, responseMaxPage, mergedResults);
        }

        return of({
          data: mergedResults,
          searchSummary: responseData['SearchSummary']
        });
      })
    );
  }

  getSearch(page = 1) {
    this.DisableSearch = true;
    this.loading = true;
    this.data = "";
    this.data = [];
    this.loadData = false;
    let datas = {};
    let split = this.siteCountryModel.split(" - ");
    let splits = this.siteCountryModelForTaxId.split(" - ");
    if (this.companyNameModel.trim() != "" && this.siteCountryModel.trim() != "") {
      datas = { name: this.companyNameModel, country: split[0].toUpperCase(), city: this.siteCityModel, _page: page, _pagesize: this.maxRecorePage }
    } else if (this.IdentifierModel.trim() != '' && this.IdentifierModel.trim().length > TWO && this.selectedIdentifierType == 'bvdid') {
      datas = { 'bvd-id': this.IdentifierModel }
    } else if (this.IdentifierModel.trim() != '' && this.IdentifierModel.trim().length > TWO && this.selectedIdentifierType == 'taxid') {
      datas = { 'national-id': this.IdentifierModel, 'country': splits[0].toUpperCase() }
    }

    this.getAllBvdSearchPages(datas).subscribe((searchResult: any) => {
      const searchData = searchResult.data;
      const searchSummary = searchResult.searchSummary;
      const totalRecords = searchSummary?.['TotalRecordsFound'] ?? searchSummary?.['RecordsReturned'] ?? searchData.length;
      this.pager = this.pagerService.getPager(totalRecords, page, searchData.length);
      if (searchData.length > 0) {
        let NDA = [];
        let ARL = [];
        searchData.forEach((element: any) => {
          if (element.MATCH[0]) {
            this.bvdSearch = false;
            if (typeof NDA[element.MATCH[0]['SCORE']] == 'undefined') {
              NDA[element.MATCH[0]['SCORE']] = [];
              ARL.push(element.MATCH[0]['SCORE']);
            }
            NDA[element.MATCH[0]['SCORE']].push(element);
          } else {
            this.bvdSearch = true;
            if (element.MATCH == undefined) {
              element.MATCH = [];
            }
            if (element.MATCH == null) {
              element.MATCH = [];
            }
            if (element.MATCH['SCORE'] == undefined) {
              element.MATCH['SCORE'] = [];
            }
            element.MATCH['SCORE'] = 1;
            if (typeof NDA[element.MATCH['SCORE']] == 'undefined') {
              NDA[element.MATCH['SCORE']] = [];
              ARL.push(element.MATCH['SCORE']);
            }
            NDA[element.MATCH['SCORE']].push(element);
          }
        });
        ARL.sort(function (a, b) { return b - a }).forEach((element: any) => {
          NDA[element].forEach(element2 => {
            this.data.push(element2)
          });
        });
        let tempSearchData = {};
        console.info('main data>>', this.data);
        this.loadData = true;
        console.info(searchResult);
        this.DisableSearch = false;
        this.loading = false;
        this.notificationService.dismissBar();
        this.PageTotalLength = this.data.length;
        if (this.data.length <= TEN) {
          this.pageHeight = this.data.length * BvdComponent.PAGE_HEIGHT_ROW_FACTOR + BvdComponent.PAGE_HEIGHT_BASE_OFFSET;
        } else {
          this.pageHeight = BvdComponent.PAGE_HEIGHT_FALLBACK;
        }
      } else {
        this.loadData = false;
        this.loading = false;
        this.DisableSearch = false;
        this.radioImpSupplier = true;
      }
    }, _error => {
      this.loading = false;
      this.loadData = false;
      this.DisableSearch = false;
      this.notificationService.showError('BvD search Error', SEARCH_ERROR_NOTIFICATION_MS);
    });
  }

  rangeAlpha(val) {
    var Res = [];
    if (val >= CONFIDENCE_A_THRESHOLD) {
      Res['Txt'] = 'A';
      Res['Clor'] = '#5CBA63';
      return Res;
    } else if (val >= CONFIDENCE_B_MIN && val <= CONFIDENCE_B_MAX) {
      Res['Txt'] = 'B';
      Res['Clor'] = '#66D8D0';
      return Res;
    } else if (val >= CONFIDENCE_C_MIN && val <= CONFIDENCE_C_MAX) {
      Res['Txt'] = 'C';
      Res['Clor'] = '#FFBD69';
      return Res;
    } else if (val >= CONFIDENCE_D_MIN && val <= CONFIDENCE_D_MAX) {
      Res['Txt'] = 'D';
      Res['Clor'] = '#CB4B32';
      return Res;
    } else if (val < CONFIDENCE_D_MIN) {
      Res['Txt'] = 'E';
      Res['Clor'] = '#632717';
      return Res;
    } else {
      Res['Txt'] = '';
      Res['Clor'] = 'grey';
      return '';
    }
  }

  clearFields(selectedField) {
    if (selectedField == "All") {
      this.IdentifierModel = '';
      this.companyNameModel = "";
      this.siteCountryModel = "";
      this.siteCityModel = "";
      this.data = "";
      this.data = [];
      this.loadData = false;
      this.siteCountryModelError = false;
      this.companyNameModelError = false;
      this.delayResCountryDuo.setValue('');
      this.delayResCountry.setValue('');
      this.IdentifierModel = '';
      this.radioImpSupplier = true;
      this.selectedIdentifierError = false;
      this.siteCountryModelForTaxId = '';
      this.disableIdentifierInput = true;
    } else {
      if (selectedField == "companyNameModel") this.companyNameModel = "";

      if (selectedField == "siteCountryModel") this.delayResCountry.setValue('');

      if (selectedField == "siteCityModel") this.siteCityModel = "";

      if (selectedField == "IdentifierValueFLag") this.IdentifierModel = "";

      if (selectedField == "siteCountryModelForTaxId") this.delayResCountryDuo.setValue('');
    }
  }

  onCountryInput(event: Event, control: UntypedFormControl) {
    const input = event.target as HTMLInputElement;
    const uppercaseValue = input.value.toUpperCase();
    if (input.value !== uppercaseValue) {
      input.value = uppercaseValue;
      control.setValue(uppercaseValue);
    }
  }

  onItemKey(event) {
    if (event['keyCode'] == KEY_ENTER && this.DisableSearch == false) {
      this.nodisplay = false;
    }
  }

  CheckImportSupplierNew() {
    this.NL_SaveGrp_ID = "";
    this.loadingImpsupp = false;
    console.info("BvD 0-7", this.BvDnumber);
    this.checkForStopOrContinue = false;
    this.BvDdata = "";
    this.BvDdata = [];
    this.NL_GUO_BvDdata = ""; // Reset GUO BVD data to prevent stale data
    this.NL_GUO_BvDdata = []; // Reset GUO BVD data arra
    this.siteDisableNext = true;
    this.companyInfos = "";
    this.companyInfos = [];
    this.GroupSelectDisab = false;
    this.groupCategoryModel = "";
    this.GroupBvDdetails = "";
    this.GroupBvDdetails = [];
    this.groupCommodityCodeModelLabel = "";
    this.commodityCodes = "";
    this.commodityCodes = [];
    this.BvDbySplitNumber = "";
    this.CompanySelectDisab = true;
    this.createdSiteBvdIds.clear();

    this.SitesInfo = "";
    this.SitesInfo = [];
    this.beRowID = "";
    this.beRowID = [];
    this.companyList = "";
    this.companyList = [];
    this.companyInfos = "";
    this.companyInfos = [];
    this.NL_Case_Occur = "";

    this.NL_flagGroup = false;
    this.NL_flagCompany = false;
    this.NL_flagSite = false;

    this.NL_flagGroup_step1Init = false;
    this.NL_flagCompany_step2Init = false;
    this.NL_flagSite_step3Init = false;

    this.importSuppStep2 = false;
    this.importSuppStep3 = false;
    this.loadingImpsupp2 = false;
    this.loadingImpsupp3 = false;
    this.loadSiteSection = false;
    this.selectedCustomCountry = '';
    this.groupCommodityCodeModelError = false;
    this.groupIdHolder = '';
    this.C2bDisplay = true;
    this.typeName = 'bop';
    this.c2bName = ''
    this.updateCreateGroupExistsName();
    this.setDefaultGroupCategoryForImport();
    if (this.BvDnumber != "") {
      var BvDAssign = this.BvDnumber.split("###");
      if (BvDAssign[0].includes(",")) {
        let variable = BvDAssign[0].split(",");
        BvDAssign[0] = variable[0];
      }
      if (BvDAssign[1].includes(",")) {
        let variable = BvDAssign[1].split(",");
        BvDAssign[1] = variable[0];
      }
      if (BvDAssign[2].includes(",")) {
        let variable = BvDAssign[2].split(",");
        BvDAssign[2] = variable[0];
      }
      this.sveCompanies = BvDAssign;
      this.BE_Check = false;
      this.guoBvdCheck = false;
      this.hqBvdCheck = false;
      this.NullCheck = false;
      this.ImportDone = false;
      this.NL_BVD_ID_NUMBER = BvDAssign[0];
      this.NL_HQ_BVD_ID_NUMBER = BvDAssign[2];
      this.NL_GUO_BVD_ID_NUMBER = BvDAssign[1];
      if (BvDAssign[2] == '' || BvDAssign[2] == 'null') {
        this.NL_HQ_BVD_ID_NUMBER = BvDAssign[0];
        BvDAssign[2] = BvDAssign[0];
      }
      if (BvDAssign[1] == '' || BvDAssign[1] == 'null') {
        this.NL_GUO_BVD_ID_NUMBER = BvDAssign[2];
        BvDAssign[1] = BvDAssign[2];
      }

      if (BvDAssign[0] != 'undefined' && BvDAssign[0] != 'null' && BvDAssign[0] != '') {
        this.NullCheck = false;
        let type = null;
        this.europeanVatNums = [];
        for (let i = 0; i < THREE; i++) {
          if (i != 0 && BvDAssign[i] != 'undefined' && BvDAssign[i] != 'null' && BvDAssign[i] != '') {
            this.BvDdata = "";
            this.BvDdata = [];
            const datas1 = { "bvd-id": BvDAssign[i], "import": "Y" }
            this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas1).subscribe((data: any) => {
              var bVdDatas = JSON.parse(data.result);
              this.BvdtoImport = bVdDatas;
              if (bVdDatas['Data'][0] != undefined && bVdDatas['Data'][0] != null) {
                this.BvDdata = bVdDatas['Data'][0];
              }
              if (i == 1) {
                type = 'GUO';
              } else if (i == TWO) {
                type = 'HQ';
              }
              console.info(`BvDdata ${BvDAssign[i]} ${type}`, this.BvDdata);
              console.info("this.BvDdata['NATIONAL_ID']", this.BvDdata['NATIONAL_ID'])
              console.info("this.BvDdata['NATIONAL_ID_LABEL']", this.BvDdata['NATIONAL_ID_LABEL'])
              if (this.BvDdata['NATIONAL_ID'] && this.BvDdata['NATIONAL_ID'].length > 0 && this.BvDdata['NATIONAL_ID'] != '') {
                var x = 0;
                this.BvDdata['NATIONAL_ID'].forEach(element => {
                  if (this.BvDdata['NATIONAL_ID_LABEL'][x] != null && element != null) {
                    console.info("CMT", this.BvDdata['NATIONAL_ID_LABEL'][x].toLowerCase());
                  }
                  x++;
                });
              }
            });
          }
        }
        const sorted = this.europeanVatNums.sort((a, b) => (a['index'] - b['index']))
        console.info("this.europeanVatNums", this.europeanVatNums);
        setTimeout(() => {
          this.stepsToImport(BvDAssign[0], BvDAssign[1], BvDAssign[2]);
        }, SHORT_DELAY_MS);
      } else {
        this.NullCheck = true;
        console.info("Connot import the supplier due to null value of BVD_ID_NUMBER:", BvDAssign[0]);
      }
    }

  }

  stepsToImport(BvDAssignBvd, BvDAssignGuo, BvDAssignHq) {
    this.cmpDetails = []
    this.grpDisp = false;
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${BvDAssignBvd}`).subscribe((data: any) => {
      if (data['business-entity-identifiers'].length > 0) {
        this.BE_Check = true;
        console.info("This Supplier is already available in ISA");
        data['business-entity-identifiers'].forEach(entityData => {
          this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${entityData['businessEntityId']}`).subscribe(cmpData => {
            let companyDetail = {
              id: cmpData['companyAllianceIdentifier'],
              name: cmpData['companyLegalName'],
              rowId: cmpData['companyId']
            }
            this.cmpDetails.push(companyDetail)
          })
        })
      } else {
        this.BE_Check = false;
        console.info("Supplier Not Exists");
        if (BvDAssignHq != 'undefined' && BvDAssignHq != 'null' && BvDAssignHq != '') {
          this.BvDbySplitNumber = BvDAssignHq;
          console.info("HQ_BVD_ID is not NULL");

          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.NL_HQ_BVD_ID_NUMBER}`).subscribe((data20: any) => {

            if (data20['business-entity-identifiers'].length > 0) {
              this.hqBvdCheck = true;
              console.info("1# HQ_BvD_ID assiciated to BE");
              console.info("1# SITE will be create with BVD_ID_NUMBER");
              this.loadingImpsupp = false;
              this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((checkForGUOBVDatGroup: any) => {
                if (checkForGUOBVDatGroup['group-identifiers'].length > 0) {
                  this.guoBvdCheck = true;
                } else {
                  this.guoBvdCheck = false;
                  this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((checkForGUOBVDatBE: any) => {
                    if (checkForGUOBVDatBE['business-entity-identifiers'].length > 0) {
                      this.guoBvdCheck = true;
                    } else {
                      this.guoBvdCheck = false;
                    }
                  });
                }
              });
              setTimeout(() => {
                this.NL_Case_Occur = 1;
                this.fetchCompany2(this.NL_HQ_BVD_ID_NUMBER);
              }, STEP_DELAY_MS);
            } else {
              console.info("HQ_BvD_ID is not assiciated to Business Entity");
              this.hqBvdCheck = false;
              if (BvDAssignGuo != 'undefined' && BvDAssignGuo != 'null' && BvDAssignGuo != '') {
                console.info("GUO_BVD_ID_NUMBER is not NULL");
                this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((data13: any) => {
                  if (data13['group-identifiers'].length > 0) {
                    console.info("Group exists and the Group is associated to that BVD");
                    this.guoBvdCheck = true;
                    setTimeout(() => {
                      this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, "GUO", FIVE);
                    }, STEP_DELAY_MS);
                  } else {
                    this.guoBvdCheck = false;
                    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((data21: any) => {

                      if (data21['business-entity-identifiers'].length > 0) {
                        console.info("2* GUO_BVD_ID Associated to Business Entity");
                        this.guoBvdCheck = true;
                        let businessEntId = data21['business-entity-identifiers'][0]['businessEntityId'];
                        this.supplierService.getBusinessEntityById(`${this.Config.ApiSupplierUrl}business-entities/${businessEntId}`).subscribe((data23: any) => {
                          if (data23) {
                            this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&companyId=${data23['companyId']}`).subscribe((data33: any) => {
                              if (data33['group-assignments'].length > 0) {
                                console.info("Group exists and the Group is ACTIVELY linked to that BVD");
                                this.grpDisp = true
                                setTimeout(() => {
                                  this.NL_Case_Occur = TWO;
                                  this.groupIdHolder = data33['group-assignments'][0]['groupId'];
                                  this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, "GUO", FIVE);
                                }, STEP_DELAY_MS);

                                console.info("2* COMPANY will be create with HQ_BVD_ID_NUMBER");
                                console.info("2* SITE will be create with BVD_ID_NUMBER");
                              } else {
                                console.info("group not actively linked to the bvd so send mail for tech err");
                                let sendMailTo = 'isa@renault.com';
                                let mailSubject = 'No Group Associated';
                                let mailContent = `<p>Hello,</p><p>There is no Group associated to that existing BVD : ${this.NL_GUO_BVD_ID_NUMBER}</p>`;
                                this.sendMailFn(sendMailTo, mailSubject, mailContent);
                                document.getElementById('closeCCBtn').click();
                                window.document.getElementById('btnWarningTechErr').click();
                              }
                            });
                          } else {
                            this.loadingImpsupp = false;
                            console.info("new group => guo_bvd does not exist at BE level");
                            setTimeout(() => {
                              this.NL_Case_Occur = TWO;
                              this.GroupBvDdetails['groupId'] = "";
                              this.importSuppStep2 = true;
                              this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, 'GUO', TWO);
                            }, STEP_DELAY_MS);
                          }
                        });

                      } else {
                        this.guoBvdCheck = false;
                        console.info("3@ GUO_BVD_ID not associated to BE");
                        setTimeout(() => {
                          this.NL_SaveGrp_ID = this.NL_GUO_BVD_ID_NUMBER;
                          this.NL_Case_Occur = THREE;
                          this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, "GUO", THREE);
                        }, STEP_DELAY_MS);

                        console.info("3@ GROUP will be create with GUO_BVD_ID_NUMBER");
                        console.info("3@ COMPANY will be create with HQ_BVD_ID_NUMBER");
                        console.info("3@ SITE will be create with BVD_ID_NUMBER");
                      }
                    });
                  }
                });
              } else {
                console.info("4_ GUO_BVD_ID_NUMBER is null1");
                setTimeout(() => {
                  this.NL_SaveGrp_ID = this.NL_HQ_BVD_ID_NUMBER;
                  this.NL_Case_Occur = FOUR;
                  this.getBvdinterfaceDetails(this.NL_HQ_BVD_ID_NUMBER, "HQ", FOUR);
                }, STEP_DELAY_MS);

                console.info("4_ GROUP will be create with HQ_BVD_ID_NUMBER");
                console.info("4_ SITE will be create with BVD_ID_NUMBER");
              }

            }
          });

        } else {
          console.info("HQ_BvD_ID is null");

          if (BvDAssignGuo != 'undefined' && BvDAssignGuo != 'null' && BvDAssignGuo != '') {
            console.info("GUO_BVD_ID_NUMBER is not null2");
            this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((data13: any) => {
              if (data13['group-identifiers'].length > 0) {
                console.info("Group exists and the Group is associated to that BVD");
                this.guoBvdCheck = true;
                setTimeout(() => {
                  this.NL_Case_Occur = FIVE;
                  this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, '', FIVE);
                }, STEP_DELAY_MS);
              } else {
                this.guoBvdCheck = false;
                this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((data22: any) => {

                  if (data22['business-entity-identifiers'].length > 0) {
                    console.info("5& GUO_BVD_ID Associated to BE");
                    console.info("5& COMPANY will be create with BVD_ID_NUMBER");
                    this.guoBvdCheck = true;
                    let businessEntId = data22['business-entity-identifiers'][0]['businessEntityId'];
                    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${businessEntId}`).subscribe((data23: any) => {
                      if (data23) {
                        this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&companyId=${data23['companyId']}`).subscribe((data33: any) => {
                          if (data33['group-assignments'].length > 0) {
                            console.info("Group exists and the Group is ACTIVELY linked to that BVD");
                            setTimeout(() => {
                              if (this.guoBvdCheck == true) {
                                this.groupIdHolder = data33['group-assignments'][0]['groupId'];
                                this.NL_Case_Occur = FIVE;
                                this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, '', FIVE);
                                this.checkForStopOrContinue = false;
                              } else {
                                this.checkForStopOrContinue = true;
                              }
                            }, STEP_DELAY_MS);
                          } else {
                            console.info("group not actively linked to the bvd so send mail for tech err");
                            let sendMailTo = 'isa@renault.com';
                            let mailSubject = 'No Group Associated';
                            let mailContent = `<p>Hello,</p><p>There is no Group associated to that existing BVD : ${this.NL_GUO_BVD_ID_NUMBER}</p>`;
                            this.sendMailFn(sendMailTo, mailSubject, mailContent);
                            document.getElementById('closeCCBtn').click();
                            window.document.getElementById('btnWarningTechErr').click();
                          }
                        });
                      } else {
                        console.info("new group => guo_bvd does not exist at BE level");
                        setTimeout(() => {
                          this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, '', FIVE);
                        }, STEP_DELAY_MS);
                      }
                    });
                  } else {
                    this.guoBvdCheck = false;
                    console.info("6% GUO_BVD_ID not Associated to BE");
                    setTimeout(() => {
                      if (BvDAssignBvd == this.NL_GUO_BVD_ID_NUMBER) {
                        console.info("6% special case GUO==BVD");
                        this.NL_Case_Occur = EIGHT;
                      } else {
                        this.NL_Case_Occur = SIX;
                      }
                      this.NL_SaveGrp_ID = this.NL_GUO_BVD_ID_NUMBER;
                      this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, "GUO", SIX);
                    }, STEP_DELAY_MS);

                    console.info("6% Group will be create with GUO_BVD_ID_NUMBER");
                    console.info("6% COMPANY will be create with BVD_ID_NUMBER");


                  }

                });
              }
            });
          } else {
            console.info("7$ GUO_BVD_ID_NUMBER is null");
            setTimeout(() => {
              this.NL_SaveGrp_ID = this.NL_BVD_ID_NUMBER;

              this.NL_Case_Occur = SEVEN;
              this.getBvdinterfaceDetails(this.NL_BVD_ID_NUMBER, "BvD", SEVEN);
            }, STEP_DELAY_MS);

            console.info("7$ Group will be create with BVD_ID_NUMBER");
          }
        }
      }
    });
  }

  ImportCheckNextNew() {
    console.info('noreload', this.noreload)
    console.info("Next", this.NL_Case_Occur);
    console.info('Array.isArray(this.GroupBvDdetails)', Array.isArray(this.GroupBvDdetails));
    console.info('NL_flagCompany', this.NL_flagCompany);
    console.info('NL_flagCompany_step2Init', this.NL_flagCompany_step2Init);
    console.info('NL_flagSite_step3Init', this.NL_flagSite_step3Init);
    console.info('NL_BVD_ID_NUMBER', this.NL_BVD_ID_NUMBER);
    console.info('NL_HQ_BVD_ID_NUMBER', this.NL_HQ_BVD_ID_NUMBER);
    console.info('NL_BvDdataCnS', this.NL_BvDdataCnS);
    console.info('GroupBvDdetails', this.GroupBvDdetails);
    this.C2bDisplay = false
    this.disableNext = false;
    this.CompanySelectDisab = true;
    this.nextBtnNotVisible = true;
    if (this.NL_Case_Occur == 1) {

      if (this.NL_Case_Occur == 1 && this.NL_flagSite_step3Init == false) {
        console.info("Site Initializing From 1");
        console.info(`Company ID is : ${this.companyRowId}`);
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);
        this.NL_flagSite_step3Init = true;
      } else if (this.NL_Case_Occur == 1 && this.NL_flagSite_step3Init == true && this.NL_flagSite == false) {
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        console.info("Site Creating From 1");
        if (this.cmpShortName == '') {
          this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${this.companyRowId}`).subscribe(data1 => {
            let cmp = data1['legalName'].split(' ').join('');
            if (cmp.length <= TEN) {
              this.cmpShortName = cmp.padEnd(TEN);
            } else if (cmp.length > TEN) {
              this.cmpShortName = cmp.slice(0, TEN);
            }
            let city = this.apiService.hasNoSpecialCharacters(this.SitesInfo['CITY_STANDARDIZED'], this.SitesInfo['CITY']);
            this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], city, this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo);
          })
        } else {
          let city = this.apiService.hasNoSpecialCharacters(this.SitesInfo['CITY_STANDARDIZED'], this.SitesInfo['CITY']);
          this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], city, this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo);
        }
        this.NL_flagSite = true;
        this.ImportDone = true;
      }
    } else if (this.NL_Case_Occur == TWO) {
      if (this.NL_Case_Occur == TWO && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == false) {
        console.info("Company Initialize 2");
        this.importSuppStep2 = true;
        this.loadingImpsupp2 = true;
        this.loadCompanySection = false;
        this.NL_flagCompany = true;
        this.getBvdinterfaceCS(this.NL_HQ_BVD_ID_NUMBER, false, true);
        this.NL_flagCompany_step2Init = true;
      } else if (this.NL_Case_Occur == TWO && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == true) {
        console.info("Company Creating From 2");
        this.importSuppStep2 = true;
        this.loadingImpsupp2 = true;
        this.loadCompanySection = false;
        console.info('bvddata to check', this.NL_BvDdataCnS);
        this.saveCompanyDetails(this.NL_BvDdataCnS['NAME'], this.NL_BvDdataCnS['NATIONAL_ID'], this.GroupBvDdetails['groupId'], this.NL_HQ_BVD_ID_NUMBER, 'N', this.NL_BvDdataCnS['NATIONAL_ID_LABEL'], 'Y', 'N', this.NL_BvDdataCnS);
        this.NL_flagCompany = true;
      } else if (this.NL_Case_Occur == TWO && this.NL_flagCompany == true && this.NL_flagSite_step3Init == false) {
        console.info("Site Initializing From 2");
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);
        this.NL_flagSite_step3Init = true;
      } else if (this.NL_Case_Occur == TWO && this.NL_flagCompany == true && this.NL_flagSite_step3Init == true && this.NL_flagSite == false) {
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        console.info("Site Creating From 2");
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${this.NL_BVD_ID_NUMBER}&businessEntityIdentifierTypeName=BVD ID`).subscribe(data2 => {
          if (data2['business-entity-identifiers'].length > 0) {
            this.fetchSiteDetails();
          } else {
            let city = this.apiService.hasNoSpecialCharacters(this.SitesInfo['CITY_STANDARDIZED'], this.SitesInfo['CITY']);
            this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], city, this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo);
          }
        });
        this.NL_flagSite = true;
        this.ImportDone = true;
      }
    } else if (Array.isArray(this.GroupBvDdetails)) {
      console.info("Group Not Exists");

      if (this.NL_Case_Occur == THREE || this.NL_Case_Occur == SIX || this.NL_Case_Occur == EIGHT) {
        console.info('case 3,6')
        this.saveGroupDetails(this.NL_GUO_BVD_ID_NUMBER, this.BvDdata['NAME']);
        this.NL_flagGroup = true;
      }
      if (this.NL_Case_Occur == FOUR) {
        console.info('case 4')
        this.saveGroupDetails(this.NL_HQ_BVD_ID_NUMBER, this.BvDdata['NAME']);
      }
      if (this.NL_Case_Occur == SEVEN) {
        console.info('case 7')
        this.saveGroupDetails(this.NL_BVD_ID_NUMBER, this.BvDdata['NAME']);
      }
    } else {
      if (this.NL_Case_Occur == THREE && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == false && (this.NL_HQ_BVD_ID_NUMBER == this.NL_GUO_BVD_ID_NUMBER)) {
        console.info("Company Initialize 3 when guo_bvd is same as hq_bvd");
        this.importSuppStep2 = true;
        this.loadingImpsupp2 = true;
        this.loadCompanySection = false;
        this.getBvdinterfaceCS(this.NL_HQ_BVD_ID_NUMBER, true, false);
        this.NL_flagCompany_step2Init = true;
        this.NL_flagCompany = true;
      } else if (this.NL_Case_Occur == THREE && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == false) {
        console.info("Company Initialize 3");
        this.importSuppStep2 = true;
        this.loadingImpsupp2 = true;
        this.loadCompanySection = false;
        this.getBvdinterfaceCS(this.NL_HQ_BVD_ID_NUMBER, false, true);
        this.NL_flagCompany_step2Init = true;
        this.NL_flagCompany = true;
      } else if (this.NL_Case_Occur == THREE && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == true) {
        console.info("Company Creating From 3");
        this.importSuppStep2 = true;
        this.loadingImpsupp2 = true;
        this.loadCompanySection = false;
        console.info('bvddata to check', this.NL_BvDdataCnS);
        this.saveCompanyDetails(this.NL_BvDdataCnS['NAME'], this.NL_BvDdataCnS['NATIONAL_ID'], this.GroupBvDdetails['groupId'], this.NL_HQ_BVD_ID_NUMBER, 'N', this.NL_BvDdataCnS['NATIONAL_ID_LABEL'], 'Y', 'N', this.NL_BvDdataCnS);
        this.NL_flagCompany = true;
      } else if (this.NL_Case_Occur == THREE && this.NL_flagCompany == true && this.NL_flagSite_step3Init == false) {
        console.info("Site Initializing From 3");
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);
        this.NL_flagSite_step3Init = true;
      } else if (this.NL_Case_Occur == THREE && this.NL_flagCompany == true && this.NL_flagSite_step3Init == true && this.NL_flagSite == false) {
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        console.info("Site Creating From 3");
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${this.NL_BVD_ID_NUMBER}&businessEntityIdentifierTypeName=BVD ID`).subscribe(data2 => {
          if (data2['business-entity-identifiers'].length > 0) {
            this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);
          } else {
            let city = this.apiService.hasNoSpecialCharacters(this.SitesInfo['CITY_STANDARDIZED'], this.SitesInfo['CITY']);
            this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], city, this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo);
          }
        });
        this.NL_flagSite = true;
        this.ImportDone = true;
      }
      if (this.NL_Case_Occur == SEVEN && this.NL_flagCompany == false) {
        console.info("Fetch Company Details from 7");
        this.ImportDone = true;
      } else if (this.NL_Case_Occur == SEVEN && this.NL_flagCompany == true && this.NL_flagSite == false) {
        console.info("Just Site Load here 7");
        this.ImportDone = true;
      }
      if ((this.NL_Case_Occur == FIVE) && this.loadingImpsupp == false && (this.importSuppStep2 == false || this.importSuppStep3 == false)) {
        if (this.importSuppStep2 == false) {
          console.info('sp case 6 called');
          this.importSuppStep2 = true;
          this.loadingImpsupp2 = true;
          this.loadCompanySection = false;
          this.getBvdinterfaceCS(this.NL_BVD_ID_NUMBER, false, true);
        } else {
          console.info('sp case 6 called-2');
          console.info('%c special case 6 called for the second time>>>>', "color : aqua;font-weight:bold", this.BEIDval);
          this.ImportDone = true;
        }
      } else if (this.NL_Case_Occur == FIVE || this.NL_Case_Occur == SIX) {
        if (this.NL_Case_Occur == SIX && this.importSuppStep2 == false) {
          this.loadingImpsupp2 = true;
          this.importSuppStep2 = true;
          this.loadCompanySection = true;
          this.getBvdinterfaceCS(this.NL_BVD_ID_NUMBER, false, true);
        } else {
          this.ImportDone = true;
        }
      } else if (this.NL_Case_Occur == EIGHT) {
        this.ImportDone = true;
      } else if (this.NL_Case_Occur == FOUR && this.NL_flagCompany == false) {
        console.info("Fetch Company Details from 4");
        this.fetchCompany2(this.NL_HQ_BVD_ID_NUMBER);
        this.NL_flagCompany = true;
      } else if (this.NL_Case_Occur == FOUR && this.NL_flagSite_step3Init == false && this.NL_flagCompany == true) {
        console.info("Site Initializing From 4");
        console.info(`Company ID is : ${this.companyRowId}`);
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);
        this.NL_flagSite_step3Init = true;
      } else if (this.NL_Case_Occur == FOUR && this.NL_flagSite_step3Init == true && this.NL_flagSite == false) {
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        console.info("Site Creating From 4");
        this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], this.SitesInfo['CITY'], this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo);
        this.NL_flagSite = true;
        this.ImportDone = true;
      }
    }

  }

  fetchSiteDetails() {
    if (this.SiteRowID != "") {
      this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?_page=1&rowId=${this.SiteRowID}&activeStatus=ACTIVE`).subscribe((dataSI: any) => {
        if (dataSI && dataSI['sites'] && dataSI['sites'].length > 0 && dataSI['sites'][0]) {
          this.SitesInfo['identifier'] = dataSI['sites'][0]['identifier'];
        } else {
        }
        console.info("this.SitesInfo", this.SitesInfo);
        this.loadSiteSection = true;
        this.loadingImpsupp3 = false;
      });
    } else {
      this.loadSiteSection = true;
      this.loadingImpsupp3 = false;
    }
    if (document.getElementById('btnForNextt')) {
      setTimeout(function () {
        document.getElementById('btnForNextt').click();
      }.bind(this), MEDIUM_DELAY_MS);
    }

  }
  fetchCompany2(BvD, from = false) {
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${BvD}`).subscribe((dataC: any) => {
      if (dataC['business-entity-identifiers'].length > 0) {
        this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?identifier=${dataC['business-entity-identifiers'][0]['businessEntityAllianceIdentifier']}`).subscribe((dataCM: any) => {
          console.info("CCCCM", dataCM);
          this.companyRowId = dataCM['business-entities'][0]['companyId'];
          this.latestCompanyId = dataCM['business-entities'][0]['companyId']
          if (from == true) {
            this.fetchCompanyDetails(BvD);
          } else {
            this.ImportCheckNextNew();
          }
        });
      } else {
        this.companyRowId = "No";
      }
    });
  }
  fetchCompanyDetails(CompanyBvD) {
    var curr_page = 1;
    this.companyInfos = "";
    this.companyInfos = [];
    this.BEIDval = "";
    this.BEIDval = [];
    this.loadingImpsupp2 = true;
    this.loadCompanySection = false;

    var cmpID = "";
    if (this.companyRowId != "" && this.companyRowId != undefined) {
      console.info("From : this.companyRowId");
      cmpID = this.companyRowId;
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${cmpID}&isHQ=Y`).subscribe((data2: any) => {
        var BEID = [];
        if (data2['business-entities'].length > 0) {
          this.companyInfos = data2['business-entities'][0];
          data2['business-entities'].forEach(element => {
            BEID.push(element.row_id);
          });
          if (BEID.length > 0) {
            this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${BEID})`).subscribe(data3 => {
                console.info("be Array", data3);
                if (data3['business-entity-identifiers'].length > 0) {
                  var y = 1;
                  data3['business-entity-identifiers'].forEach(element => {
                    this.BEIDval[element.businessEntityId] = element.value;
                    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=*${element.value}`).subscribe(data0 => {
                      if (data0['business-entity-identifiers'].length > 0) {
                        this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=in(${data0['business-entity-identifiers'][0]['businessEntityId']})`).subscribe(data30 => {
                          if (data30['site-assignments'].length > 0) {
                            let c = data30['site-assignments'][0].site.href.split('/');
                            this.siteService.getSites(`${this.Config.ApiSitesUrl}sites/${c[1]}?activeStatus=ACTIVE`).subscribe(data50 => {
                              if (data50?.['identifier']) {
                                this.BEIDval[element.value] = data50['identifier']
                              }
                              this.loadingImpsupp2 = false;
                              this.loadCompanySection = true;
                            });
                          } else {
                            this.loadingImpsupp2 = false;
                            this.loadCompanySection = true;
                          }
                        });

                      } else {
                        this.loadingImpsupp2 = false;
                        this.loadCompanySection = true;
                      }
                    });

                  });
                  console.info("sA", this.BEIDval);
                } else {
                  this.loadingImpsupp2 = false;
                  this.loadCompanySection = true;
                }
              });

          } else {
            this.loadingImpsupp2 = false;
            this.loadCompanySection = true;
          }

        } else {
          this.loadingImpsupp2 = false;
          this.loadCompanySection = true;
        }
        console.info("Company Infos", this.companyInfos);
        if (document.getElementById('btnForNextt')) {
          setTimeout(function () {
            const btnForNextt = document.getElementById('btnForNextt');
            if (btnForNextt) {
              btnForNextt.click();
            }
          }.bind(this), MEDIUM_DELAY_MS);
        }
      });
    } else {
      this.fetchCompany2(CompanyBvD, true);
    }

  }
  getBvdinterfaceSite(BvD_HQBvD_GuoBvD, _cmpBVD = '') {
    if (this.noreload == true) {
      this.noreload = false
      this.siteDisableNext = true;
      this.NL_flagSite_step3Init = true;
      this.loadSiteSection = true;
      this.loadingImpsupp3 = false;
    } else {
      const datas = { "bvd-id": BvD_HQBvD_GuoBvD, import: "Y" }
      this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => {
        var bVdDatas = JSON.parse(data.result);
        let tempData = '';
        if (this.SitesInfo.length !== 0 || this.SitesInfo !== '') {
          tempData = this.SitesInfo['identifier'];  
        }
        this.SitesInfo = bVdDatas['Data'][0];
        if (tempData != '') {   
          this.SitesInfo['identifier'] = tempData;
          this.SitesInfo['c2b'] = this.c2bName
        }
        console.info("BvD-SiteLog", this.SitesInfo);
        if (document.getElementById('btnForNextt')) {
          this.siteDisableNext = false
          this.noreload = true
          setTimeout(function () {
            document.getElementById('btnForNextt').click();
            this.siteDisableNext = true;
          }.bind(this), MEDIUM_DELAY_MS);
        }
        this.NL_flagSite_step3Init = true;
        this.loadingImpsupp3 = false;

      }, _error => {
        this.groupCurrentStatus = 'BvD interface API error (Timeout)';
      });
    }
  }
  getBvdinterfaceCS(BvD_HQBvD_GuoBvD, LoadCompnay = false, loadCpyDet = false) {
    this.NL_BvDdataCnS = "";
    this.NL_BvDdataCnS = [];
    const datas = { "bvd-id": BvD_HQBvD_GuoBvD, import: "Y" }
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => {
      var bVdDatas = JSON.parse(data.result);
      this.NL_BvDdataCnS = bVdDatas['Data'][0];
      console.info("BvD-CnS : this.NL_BvDdataCnS", this.NL_BvDdataCnS);
      console.info('load cpy', loadCpyDet);
      if (loadCpyDet == true) {
        console.info('bvddata to check', this.NL_BvDdataCnS);
        this.saveCompanyDetails(this.NL_BvDdataCnS['NAME'], this.NL_BvDdataCnS['NATIONAL_ID'], this.GroupBvDdetails['groupId'], BvD_HQBvD_GuoBvD, 'N', this.NL_BvDdataCnS['NATIONAL_ID_LABEL'], 'Y', 'N', this.NL_BvDdataCnS);
      } else {
        if (LoadCompnay == true) {
          this.fetchCompanyDetails(BvD_HQBvD_GuoBvD);
        } else {
          this.loadingImpsupp2 = false;
        }
      }
    }, _error => {
      this.groupCurrentStatus = 'BvD interface API error (Timeout)';
    });
  }
  getBvdinterfaceDetails(BvD_HQBvD_GuoBvD, Type = null, from) {
    this.BvDdata = "";
    this.BvDdata = [];
    const datas = { "bvd-id": BvD_HQBvD_GuoBvD, "import": "Y" }
    this.groupCurrentStatus = 'Fetching BvD details from BvD interface';
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => {
      var bVdDatas = JSON.parse(data.result);
      if (bVdDatas['Data'][0] != undefined && bVdDatas['Data'][0] != null) {
        this.BvDdata = bVdDatas['Data'][0];
      }
      console.info(`BvDdata ${BvD_HQBvD_GuoBvD} ${Type}`, this.BvDdata);
      if (Type === "GUO") {
        this.NL_GUO_BvDdata = JSON.parse(JSON.stringify(this.BvDdata)); // Deep copy to prevent reference issues
        console.info("[FIX] Stored GUO BVD data separately:", this.NL_GUO_BvDdata['BVD_ID_NUMBER']);
      }
      if (from == THREE || from == FOUR || from == SIX || from == SEVEN || from == FIVE) {
        this.fetchGroupDetails(BvD_HQBvD_GuoBvD, Type);
        this.groupCurrentStatus = 'Fetching Group details';
      }
      if (from == 1 || from == TWO) {
        this.groupCurrentStatus = 'Fetching Group details';
        this.fetchGroupID(BvD_HQBvD_GuoBvD);
      }
    }, _error => {
      this.groupCurrentStatus = 'BvD interface API error (Timeout)';
    });
  }

  fetchGroupID(BvD_HQBvD_GuoBvD) {
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${BvD_HQBvD_GuoBvD}`).subscribe((data3: any) => {
      if (data3['group-identifiers'].length > 0) {
        this.GroupBvDdetails['groupId'] = data3['group-identifiers'][0]['groupId'];
        console.info("Group ID is : ", this.GroupBvDdetails['groupId']);
      } else {
        console.info("Group ID not assigned");
        this.GroupBvDdetails['groupId'] = "";
      }
      this.CompanySelectDisab = false;
    });
  }

  fetchGroupDetails(BvD_HQBvD_GuoBvD, Type = null) {
    this.AllgroupCategories();
    const datas = { "bvd-id": BvD_HQBvD_GuoBvD }
    this.groupCurrentStatus = 'Fetching Group details';
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${BvD_HQBvD_GuoBvD}`).subscribe((data3: any) => {
      console.info('fetchgroupdetails', data3);
      let groupName = this.BvDdata['NAME'];
      if (groupName != '' && groupName != undefined) {
        this.disableGrpShortNameLoad = true;
        this.setGroupNameDynamicFn(groupName);
      }
      if (data3['group-identifiers'].length > 0) {
        this.nextBtnNotVisible = true;
        this.GroupBvDdetails = data3['group-identifiers'][0];

        this.supplierService.getGroupById(`${this.Config.ApiSupplierUrl}groups/${data3['group-identifiers'][0]['groupId']}`).subscribe((data: any) => {
          this.groupCategoryModel = data['groupTypeCode'];
          if (this.groupCategoryModel != "") {
            this.GroupSelectDisab = true;
            this.CompanySelectDisab = false;
          }
          console.info("Group Cat Model", this.groupCategoryModel);

        });
        var curr_page = 1;
        this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?_page=${curr_page}&groupId=${this.GroupBvDdetails['groupId']}`).subscribe((data: any) => {
          if (data['group-assignments'].length > 0) {
            this.GroupBvDdetails['companyAllianceIdentifier'] = data['group-assignments'][0]['companyAllianceIdentifier'];
          }
          if (Type == "Hide") {

          }
        });
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=*${BvD_HQBvD_GuoBvD}`).subscribe(data0 => {
          if (data0['business-entity-identifiers'].length > 0) {
            this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=in(${data0['business-entity-identifiers'][0]['businessEntityId']})`).subscribe(data30 => {
              if (data30['site-assignments'].length > 0) {
                let c = data30['site-assignments'][0].site.href.split('/');
                this.siteService.getSites(`${this.Config.ApiSitesUrl}sites/${c[1]}?activeStatus=ACTIVE`).subscribe(data50 => {
                  if (data50?.['identifier']) {
                    this.GroupBvDdetails['siteAllianceIdentifier'] = data50['identifier']
                  }
                  this.loadingImpsupp = false;
                  this.groupCurrentStatus = 'Fetching Site details';
                });
              } else {
                this.loadingImpsupp = false;
              }
            });

          } else {
            this.loadingImpsupp = false;
          }

        });

        this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupId=${data3['group-identifiers'][0]['groupId']}`).subscribe((data: any) => {
          if (data['group-identifiers'] && data['group-identifiers'] != null) {
            data['group-identifiers'].forEach(element => {
              if (element.groupIdentifierKeyName.toLowerCase() == 'mdm group') {
                this.GroupBvDdetails['shortNme'] = element.value;
              }
            });

          }
          this.disableNext = false;

          if (document.getElementById('btnForNextt')) {
            console.info("next btn clicked")
          }
        });
        console.info("G1", this.GroupBvDdetails);
      } else {
        if (this.groupIdHolder != '') {
          this.groupCurrentStatus = 'Fetching Group details';
          this.nextBtnNotVisible = true;
          this.GroupBvDdetails['groupId'] = this.groupIdHolder;
          this.GroupSelectDisab = true;
          this.CompanySelectDisab = this.grpDisp ? false : true;
          this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupId=${this.groupIdHolder}`).subscribe((data3: any) => {
            if (data3['group-identifiers'].length > 0) {
              this.GroupBvDdetails = data3['group-identifiers'][0];
              this.GroupBvDdetails['shortNme'] = data3['group-identifiers'][0]['value'];
              this.GroupBvDdetails['value'] = BvD_HQBvD_GuoBvD;
              this.GroupBvDdetails['groupAllianceIdentifier'] = data3['group-identifiers'][0]['groupAllianceIdentifier'];

              this.supplierService.getGroupById(`${this.Config.ApiSupplierUrl}groups/${data3['group-identifiers'][0]['groupId']}`).subscribe((data: any) => {
                this.groupCategoryModel = data['groupTypeCode'];
                if (this.groupCategoryModel != "") {
                }
                console.info("Group Cat Model", this.groupCategoryModel);

              });
              var curr_page = 1;
              this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?_page=${curr_page}&groupId=${this.GroupBvDdetails['groupId']}`).subscribe((data: any) => {
                if (data['group-assignments'].length > 0) {
                  this.GroupBvDdetails['companyAllianceIdentifier'] = data['group-assignments'][0]['companyAllianceIdentifier'];
                }
                if (Type == "Hide") {

                }
              });
              this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=*${BvD_HQBvD_GuoBvD}`).subscribe(data0 => {
                if (data0['business-entity-identifiers'].length > 0) {
                  this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=in(${data0['business-entity-identifiers'][0]['businessEntityId']})`).subscribe(data30 => {
                    if (data30['site-assignments'].length > 0) {
                      let c = data30['site-assignments'][0].site.href.split('/');
                      this.siteService.getSites(`${this.Config.ApiSitesUrl}sites/${c[1]}?activeStatus=ACTIVE`).subscribe(data50 => {
                        if (data50?.['identifier']) {
                          this.GroupBvDdetails['siteAllianceIdentifier'] = data50['identifier']
                        }
                        this.loadingImpsupp = false;
                        this.groupCurrentStatus = 'Fetching Site details';
                      });
                    } else {
                      this.loadingImpsupp = false;
                    }
                  });

                } else {
                  this.loadingImpsupp = false;
                }

              });

              this.supplierService.getGroupIdentifierKeysById(`${this.Config.ApiSupplierUrl}group-identifiers?groupId=${data3['group-identifiers'][0]['groupId']}`).subscribe((data: any) => {
                if (data['group-identifiers'] && data['group-identifiers'] != null) {
                  data['group-identifiers'].forEach(element => {
                    if (element.groupIdentifierKeyName.toLowerCase() == 'mdm group') {
                      this.GroupBvDdetails['shortNme'] = element.value;
                    }
                  });

                }
                this.disableNext = false;

                if (document.getElementById('btnForNextt')) {
                  console.info("next btn clicked-----")
                  if (!this.grpDisp) {
                    setTimeout(function () {
                      document.getElementById('btnForNextt').click();
                    }.bind(this), MEDIUM_DELAY_MS);
                  } else {
                    this.importSuppStep3 = true;
                  }
                }

              });
              console.info("G1", this.GroupBvDdetails);
            }
          }, _error => {
            this.loadingImpsupp = false;
            this.disableNext = false;
          });
        } else {
          console.info('in else show group select');
          this.loadingImpsupp = false;
          this.GroupSelectDisab = false;
        }
      }
    });
  }
  replaceCharacter(string, index, replacement) {
    return (
      string.slice(0, index) +
      replacement +
      string.slice(index + replacement.length)
    );
  }

  setGroupNameDynamicFn(grpName: string, loop = 'start', loopCount = 1, authGrpName = '', unoModify = '') {
    if (loop == 'start') {
      authGrpName = grpName.replace(/[^a-zA-Z0-9]/g, '').substring(0, SIX).toUpperCase();
      grpName = authGrpName;
    }
    else if (loop == 'continue') {
      if (loopCount == TWO) {
        unoModify = '6'
      }
      if (loopCount == 2 && grpName.length != SIX) {
        unoModify = grpName.length.toString();
        grpName = grpName.concat(this.digitsArray[0]);
      }
      let lastLetter = grpName.substr(grpName.length - 1);
      let indi1 = this.alphabetsArray.indexOf(lastLetter);
      let indi2 = this.digitsArray.indexOf(lastLetter);
      let nextLetter = '';
      if (indi1 != -1 && lastLetter != 'Z') {
        nextLetter = this.alphabetsArray[indi1 + 1];
      } else if (lastLetter == 'Z') {
        let short_modify = grpName.charAt(grpName.length - TWO)
        let indi3 = this.alphabetsArray.indexOf(short_modify);
        let indi4 = this.digitsArray.indexOf(short_modify);
        let newLeter = "";
        if (indi4 != -1 && short_modify != '9') {
          newLeter = this.digitsArray[indi2 + 1];
        } else if (indi1 == -1) {
          newLeter = this.alphabetsArray[0];
        } else if (indi1 != -1) {
          if (short_modify != 'Z') {
            newLeter = this.alphabetsArray[indi3 + 1];
          }
          else {
            newLeter = this.alphabetsArray[0];
          }

        }
        grpName = grpName.slice(0, grpName.length - TWO) + newLeter + this.alphabetsArray[0];
        console.info('grpname', grpName)

      }
      if (lastLetter != 'Z') {
        if (indi2 != -1 && lastLetter != '9') {
          nextLetter = this.digitsArray[indi2 + 1];
        } else if (indi1 == -1) {
          nextLetter = this.alphabetsArray[0];
        }
        grpName = grpName.slice(0, -1);
        grpName = grpName.concat(nextLetter);
      }
      grpName = grpName.split(' ').join('').toUpperCase().substring(0, SIX);
    }
    loopCount++;
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?value=${grpName}&_page=1`).subscribe(data => {
      if (data['pageCount'] == 0) {
        this.disableGrpShortNameLoad = false;
        console.info('Set group short name', grpName, '>>', grpName.length, 'loop cut at', loopCount);
        this.groupShortName = grpName;
        this.disableNext = false;
        this.nextBtnNotVisible = false;
      } else {
        this.setGroupNameDynamicFn(grpName, 'continue', loopCount, authGrpName, unoModify);
      }
    });
  }

  c2bValueDisplay() {
    if (this.typeName == 'nbop') {
      this.displayC2b = true
      this.disableNext = true
      this.c2bValue = true
      this.c2bError = false
    } else {
      this.displayC2b = false
      this.c2bName = ''
      this.disableNext = false
    }
  }

  saveGroupDetails(Group_BvD, GrpName) {
    this.loadingImpsupp = true;
    GrpName = GrpName ? GrpName.substring(0, SIXTY) : '';
    this.groupNameModel = GrpName;
    let proceedShortName = false;
    if (GrpName != '' && GrpName != undefined && this.groupCategoryModel != '' && this.groupCategoryModel != undefined && this.groupShortName != '' && this.groupShortName != undefined && this.groupShortNameRegExError == false) {
      this.groupShortNameError = false;
      this.groupShortNameExistsError = false;
      this.groupNameModelError = false;
      this.groupCategoryModelError = false;
      this.groupCurrentStatus = 'Creating Group';
      this.nextBtnNotVisible = true;
      this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?value=${this.groupShortName}&_page=1`).subscribe(data0 => {
        if (data0['pageCount'] == 0) {
          proceedShortName = true;
          this.groupShortNameExistsError = false;
        } else {
          this.saveDatas = 'Save';
          this.groupShortNameExistsError = true;
          proceedShortName = false;
        }
        if (proceedShortName) {
          console.info("**** Create Group is Processing ****");
          console.info(`Group BvD ID : ${Group_BvD} Group Name : ${GrpName}`);
          let grpIdentifierKeyId = "";
          let mdmGroupKey = "";
          this.supplierService.getGroupIdentifierKeys(`${this.Config.ApiSupplierUrl}group-identifier-keys`).subscribe((data18: any) => {
            data18['group-identifier-keys'].forEach(element => {
              if (element.name.toLowerCase() == "bvd") {
                grpIdentifierKeyId = element.row_id;
              }
              if (element.name.toLowerCase() == "mdm group") {
                mdmGroupKey = element.row_id;
              }
            });
            var StartDates = this.apiService.getTodayDate();
            this.groupNameModel = this.groupNameModel.substring(0, SIXTY);
            const datas = { name: this.groupNameModel, groupTypes: this.groupCategoryModel, modificationStatus: 'VALIDATED', startDate: StartDates };
            this.supplierService.createGroups(`${this.Config.ApiSupplierUrl}groups`, datas).subscribe((dataGroup: any) => {
              console.info(`New Group ID is : ${dataGroup['row_id']}`);
              this.groupIdHolder = dataGroup['row_id'];
              this.groupShortName = this.groupShortName.substring(0, SIX);
              const datas2 = {
                "groupId": dataGroup['row_id'],
                "value": this.groupShortName,
                "groupIdentifierKeyId": mdmGroupKey,
                "startDate": StartDates
              }
              this.supplierService.CreateGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers`, datas2).subscribe(_data => {

                });
              this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes?code=prospect`).subscribe((data: any) => {
                this.commodityCodeScopeRowid = data['approval-scopes'][0]['row_id'];

                if (this.commodityCodeScopeRowid != '' && this.groupCommodityCodeModel != '' && this.commodityCodeScopeRowid != '') {
                  const datas3 = { groupPwo: `SupPurchasingWorkingOrganizationService:${this.groupCommodityCodeModel}`, groupId: dataGroup['row_id'], scopeId: this.commodityCodeScopeRowid, type: 'GROUP', scopeCode: 'Prospect', approvalModificationStatus: 'VALIDATED', validityStartDate: StartDates };
                  this.supplierService.CreateGroupApprovals(`${this.Config.ApiSupplierUrl}group-approvals`, datas3).subscribe((_dataGApprovals: any) => {

                  });
                }
              });
              console.info("**** Create Group DONE ****");
              console.info('bvddata to check', this.NL_GUO_BvDdata);
              const guoBvdData = this.NL_GUO_BvDdata && this.NL_GUO_BvDdata['BVD_ID_NUMBER'] ? this.NL_GUO_BvDdata : this.BvDdata;
              this.saveCompanyDetails(this.groupNameModel, guoBvdData['NATIONAL_ID'], dataGroup['row_id'], Group_BvD, 'Y', guoBvdData['NATIONAL_ID_LABEL'], 'N', 'N', guoBvdData);
            });
          });
        } else {
          this.loadingImpsupp = false;
          this.nextBtnNotVisible = false;
          this.disableNext = false;
        }
      });
    } else {
      this.loadingImpsupp = false;
      console.info("Missing Mandatory Fields");
      if (this.groupShortName == '') {
        this.groupShortNameError = true;
      }
      if (this.groupCategoryModel == '') {
        this.groupCategoryModelError = true;
      }
    }
  }

  saveCompanyDetails(cmpName: string, cmpMainTaxId, groupId, BvdforComP, RepresentCompany, cmpMainTaxIdLabel, fromCnS = 'N', fromSpCase = 'N', bvdDataOverride: any = null) {
    this.groupCurrentStatus = 'Creating Company';
    this.nextBtnNotVisible = true;
    const effectiveBvDdata = bvdDataOverride || this.BvDdata;
    console.info("[FIX] saveCompanyDetails using BVD data for:", effectiveBvDdata['BVD_ID_NUMBER']);
    if (cmpName != '' && cmpName != undefined) {
      this.AllCompanyIdentifierTypes();
      this.companyStatusRowid = "";
      console.info("**** Create Company is Processing ****");
      console.info(`Company Name : ${cmpName} Main TaxID : ${cmpMainTaxId} Group ID : ${groupId} BvDID for Company${BvdforComP}`);

      var cmpNameTypeID = "";
      this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types`).subscribe((data18: any) => {
        console.info("company-name-types", data18);
        data18['company-name-types'].forEach(element => {
          if (element.name.toLowerCase() == "short name") {
            cmpNameTypeID = element.row_id;
          }
        });
      });

      var StartDates = this.apiService.getTodayDate();
      this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status`).subscribe((data: any) => {
        data['company-status'].forEach(element => {
          if (element.code.toLowerCase() == "identified") {
            this.companyStatusRowid = element.row_id
          }
        });
        if (this.companyStatusRowid != '' && this.typeName == "bop") {
          cmpName = cmpName.substring(0, SIXTY);
          const datas = { legalName: cmpName, companyStatusId: this.companyStatusRowid, companyStatusCode: 'Identified', startDate: StartDates };
          this.supplierService.createCompany(`${this.Config.ApiSupplierUrl}companies?noMdm=1`, datas).subscribe((dataGroup: any) => {
            console.info(`Created new Company ID is : ${dataGroup['rowId']}`);
            this.latestCompanyId = dataGroup['rowId'];
            console.info('[BOP TAG CHECK] BvdforComP:', BvdforComP, 'NL_BVD:', this.NL_BVD_ID_NUMBER, 'NL_HQ:', this.NL_HQ_BVD_ID_NUMBER, 'RepresentCompany:', RepresentCompany);
            if (BvdforComP == this.NL_BVD_ID_NUMBER || BvdforComP == this.NL_HQ_BVD_ID_NUMBER || RepresentCompany == "Y") {
              console.info('[BOP TAG] Applying B#BOP tag to company:', this.latestCompanyId);
              let activityData = {
                "companyNameTypeName": "SUPPLIER ACTIVITY",
                "companyId": this.latestCompanyId,
                "endDate": "",
                "companyNameTypeId": "6",
                "value": 'B#BOP',
                "startDate": this.apiService.getTodayDate(),
              }
              this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, activityData).subscribe((_data: any) => {
                console.info('[BOP TAG] Successfully applied B#BOP tag');
              })
            } else {
              console.info('[BOP TAG] NOT applying - conditions not met');
            }
            if (this.typeName != "") {
              this.GroupSelectDisab = true;
            }
            if (fromCnS == "Y" || this.NL_Case_Occur == SEVEN) {
              this.companyRowId = dataGroup['rowId'];
            }
            if (cmpMainTaxId && cmpMainTaxId.length > 0 && cmpMainTaxId != '') {

              var x = 0;
              console.info("this.IdenKeywithId", this.IdenKeywithId);
              cmpMainTaxId.forEach(element => {
                if (cmpMainTaxIdLabel[x] != null && element != null) {
                  var mainTaxRowid = "";
                  console.info("CMT", cmpMainTaxIdLabel[x]);
                  mainTaxRowid = this.IdenKeywithId[cmpMainTaxIdLabel[x].toLowerCase()];
                  console.info(mainTaxRowid);
                  if (mainTaxRowid != undefined && mainTaxRowid != "" && (cmpMainTaxIdLabel[x].toLowerCase() == 'european vat number')) {
                    element = element.substring(0, TWENTY);
                    var datas21 = { linkedCompanyId: dataGroup['rowId'], companyIdentifierTypeId: mainTaxRowid, value: element.replace(" ", ""), startDate: StartDates };
                    this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas21).subscribe((_dataGApprovals: any) => {
                    });
                  }
                }
                x++;
              });
            }
            let shortName = cmpName.split(' ').join('');
            if (shortName.length <= TEN) {
              shortName = shortName.padEnd(TEN);
            } else if (shortName.length > TEN) {
              shortName = shortName.slice(0, TEN);
            }
            shortName = shortName.substring(0, 10);
            this.cmpShortName = shortName
            const datas3 = { companyId: dataGroup['rowId'], companyNameTypeId: cmpNameTypeID, "value": shortName, startDate: StartDates }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas3).subscribe((_data: any) => {

            })
            let today = new Date();
            let dd = String(today.getDate()).padStart(TWO, '0');
            let mm = String(today.getMonth() + 1).padStart(TWO, '0');
            let yyyy = today.getFullYear();
            let todayDate = `${yyyy}-${mm}-${dd}`;
            const datas5 = {
              "apoStatus": "ACTIVE",
              "companyId": dataGroup['rowId'],
              "groupTypeCode": "",
              "groupId": groupId,
              "validityStartDate": todayDate,
              "status": "VALIDATED",
              "groupTypeId": TWO
            };
            this.groupCurrentStatus = 'Creating Group Assignment';
            this.nextBtnNotVisible = true;
            this.supplierService.CreateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments`, datas5).subscribe((_data: any) => {
              this.saveDatas = "Save";
              var BvDAssign = this.sveCompanies;
              console.info("**** Create Company Done ****");
              if (fromCnS == "Y") {
                console.info("Company Module");
                if (fromSpCase == 'Y') {
                  console.info('NL_BvDdataCnS', this.NL_BvDdataCnS);
                  console.info('effectiveBvDdata', effectiveBvDdata);
                  let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                    this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata);
                } else {
                  let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                  this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata);
                }
              } else {
                console.info("Group Module");
                let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                    this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata);
              }
              this.groupMdmSwitch = true
              console.info("**** Create Company Done ****");

            });

            if (RepresentCompany == "Y") {
              const const1 = { representingCompanyId: dataGroup['rowId'] }
              this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`, const1).subscribe(_data => {
              });
            }
          });
        }
        else if (this.companyStatusRowid != '' && (this.typeName == 'nbop' || this.typeName == 'finance')) {
          cmpName = cmpName.substring(0, SIXTY);
          const datas = { legalName: cmpName, companyStatusId: this.companyStatusRowid, companyStatusCode: 'Identified', startDate: StartDates };
          this.supplierService.createCompany(`${this.Config.ApiSupplierUrl}companies?noMdm=1`, datas).subscribe((dataGroup: any) => {
            console.info(`Created new Company ID is : ${dataGroup['rowId']}`);
            this.latestCompanyId = dataGroup['rowId'];
            this.GroupSelectDisab = true;
            console.info('[NBOP/FIN TAG CHECK] BvdforComP:', BvdforComP, 'NL_BVD:', this.NL_BVD_ID_NUMBER, 'NL_HQ:', this.NL_HQ_BVD_ID_NUMBER, 'RepresentCompany:', RepresentCompany, 'typeName:', this.typeName);
            
            if (BvdforComP == this.NL_BVD_ID_NUMBER || BvdforComP == this.NL_HQ_BVD_ID_NUMBER || RepresentCompany == "Y") {
              const isImportedCompany = (BvdforComP == this.NL_BVD_ID_NUMBER || BvdforComP == this.NL_HQ_BVD_ID_NUMBER);
              const isRepresentingCompany = (RepresentCompany == "Y");
              
              if (this.typeName == 'finance') {
                // For FINANCE: imported company gets FINANCE + NBOP, representing company gets only NBOP
                if (isImportedCompany) {
                  console.info('[FINANCE TAG] Applying B#FINANCE tag to imported company:', this.latestCompanyId);
                  let financeData = {
                    "companyNameTypeName": "SUPPLIER ACTIVITY",
                    "companyId": this.latestCompanyId,
                    "endDate": "",
                    "companyNameTypeId": "6",
                    "value": 'B#FINANCE',
                    "startDate": this.apiService.getTodayDate(),
                  }
                  this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, financeData).subscribe((_data: any) => {
                    console.info('[FINANCE TAG] Successfully applied B#FINANCE tag');
                  })
                }
                // Apply NBOP to both imported and representing company for FINANCE type
                console.info('[NBOP TAG] Applying B#NBOP tag (for FINANCE type) to company:', this.latestCompanyId);
                let nbopData = {
                  "companyNameTypeName": "SUPPLIER ACTIVITY",
                  "companyId": this.latestCompanyId,
                  "endDate": "",
                  "companyNameTypeId": "6",
                  "value": 'B#NBOP',
                  "startDate": this.apiService.getTodayDate(),
                }
                this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, nbopData).subscribe((_data: any) => {
                  console.info('[NBOP TAG] Successfully applied B#NBOP tag');
                })
              } else {
                // For NBOP type: apply NBOP to both imported and representing company
                console.info('[NBOP TAG] Applying B#NBOP tag to company:', this.latestCompanyId);
                let nbopData = {
                  "companyNameTypeName": "SUPPLIER ACTIVITY",
                  "companyId": this.latestCompanyId,
                  "endDate": "",
                  "companyNameTypeId": "6",
                  "value": 'B#NBOP',
                  "startDate": this.apiService.getTodayDate(),
                }
                this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, nbopData).subscribe((_data: any) => {
                  console.info('[NBOP TAG] Successfully applied B#NBOP tag');
                })
              }
            } else {
              console.info('[ACTIVITY TAG] NOT applying - conditions not met');
            }
            if (fromCnS == "Y" || this.NL_Case_Occur == SEVEN) {
              this.companyRowId = dataGroup['rowId'];
            }
            else {
              this.GroupSelectDisab = false;
            }
            if (cmpMainTaxId && cmpMainTaxId.length > 0 && cmpMainTaxId != '') {

              var x = 0;
              console.info("this.IdenKeywithId", this.IdenKeywithId);
              cmpMainTaxId.forEach(element => {
                if (cmpMainTaxIdLabel[x] != null && element != null) {
                  var mainTaxRowid = "";
                  console.info("CMT", cmpMainTaxIdLabel[x]);
                  mainTaxRowid = this.IdenKeywithId[cmpMainTaxIdLabel[x].toLowerCase()];
                  console.info(mainTaxRowid);
                  if (mainTaxRowid != undefined && mainTaxRowid != "" && (cmpMainTaxIdLabel[x].toLowerCase() == 'european vat number')) {
                    element = element.substring(0, TWENTY);
                    var datas21 = { linkedCompanyId: dataGroup['rowId'], companyIdentifierTypeId: mainTaxRowid, value: element.replace(" ", ""), startDate: StartDates };
                    this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas21).subscribe((_dataGApprovals: any) => {
                    });
                  }
                }
                x++;
              });
            }
            let shortName = cmpName.split(' ').join('');
            if (shortName.length <= TEN) {
              shortName = shortName.padEnd(TEN);
            } else if (shortName.length > TEN) {
              shortName = shortName.slice(0, TEN);
            }
            shortName = shortName.substring(0, 10);
            this.cmpShortName = shortName
            const datas3 = { companyId: dataGroup['rowId'], companyNameTypeId: cmpNameTypeID, "value": shortName, startDate: StartDates }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas3).subscribe((_data: any) => {

            })
            let today = new Date();
            let dd = String(today.getDate()).padStart(TWO, '0');
            let mm = String(today.getMonth() + 1).padStart(TWO, '0');
            let yyyy = today.getFullYear();
            let todayDate = `${yyyy}-${mm}-${dd}`;
            const datas5 = {
              "apoStatus": "ACTIVE",
              "companyId": dataGroup['rowId'],
              "groupTypeCode": "",
              "groupId": groupId,
              "validityStartDate": todayDate,
              "status": "VALIDATED",
              "groupTypeId": TWO
            };
            this.groupCurrentStatus = 'Creating Group Assignment';
            this.nextBtnNotVisible = true;
            this.supplierService.CreateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments`, datas5).subscribe((_data: any) => {
              this.saveDatas = "Save";
              var BvDAssign = this.sveCompanies;
              console.info("**** Create Company Done ****");
              console.info('NL_BvDdataCnS',this.NL_BvDdataCnS);
              console.info('effectiveBvDdata',effectiveBvDdata);
              console.info('bvd',this.sveCompanies)
              if (fromCnS == "Y") {
                console.info("Company Module");
                if (fromSpCase == 'Y') {
                  console.info('NL_BvDdataCnS', this.NL_BvDdataCnS);
                  console.info('BvDdata', this.BvDdata);
                  let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                    this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata);
                } else {
                  let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                    this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata);
                }
              } else {
                console.info("Group Module");
                this.saveSitesDetails(cmpName, this.BvDdata['COUNTRY'], this.BvDdata['COUNTRY_ISO_CODE'], this.BvDdata['CITY'], this.BvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, "N", this.BvDdata);
              }
              this.groupMdmSwitch = false
              console.info("**** Create Company Done ****");

            });

            if (RepresentCompany == "Y") {
              const const1 = { representingCompanyId: dataGroup['rowId'] }
              this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`, const1).subscribe(_data => {
              });
            }
          });
        }
      });

    }
  }

  checkSelRunSite() {
    if (this.selectedCustomCountry != '') {
      let split = this.selectedCustomCountry.split(" - ");
      this.saveSitesDetails(this.tempVarCounList['CmpName'], split[1], split[0], this.tempVarCounList['CityName'], this.tempVarCounList['Postal'], this.tempVarCounList['CompanayID'], this.tempVarCounList['BvDidforsite'], this.tempVarCounList['fromCnS'], this.tempVarCounList['thisBvDdata'], this.tempVarCounList['times'], 'yes');
    }
  }

  saveSitesDetails(CmpName, counName, counCode, CityName, Postal, CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = [], times = 1, counFilter = 'none') {

    if (times === 1 && counFilter !== 'yes') {
      if (this.createdSiteBvdIds.has(BvDidforsite)) {
        console.info("[DUPLICATE PREVENTION] Site already created or in progress for BVD:", BvDidforsite);
        return;
      }
      this.createdSiteBvdIds.add(BvDidforsite);
      console.info("[DUPLICATE PREVENTION] Marked BVD for site creation:", BvDidforsite);
    }

    console.info("[DEBUG] saveSitesDetails STARTED - ImportDone:", this.ImportDone, "fromCnS:", fromCnS);
    console.info("thisBvDdata", thisBvDdata);
    console.info("**** Create Site Processing ****");
    console.info(`Site Name : ${CmpName} ${CityName} Country : ${counName} CountryCode : ${counCode} City Name :${CityName} Postal : ${Postal} Company ID${CompanayID} BvD for Site${BvDidforsite}`);
    console.info('debug>>', this.CountryNameKeyId);
    this.groupCurrentStatus = 'Creating Site';
    this.nextBtnNotVisible = true;
    this.selectedCountry = counName;
    if (CityName == undefined || CityName == '' || CityName == null) {
      CityName = 'UNKNOWN';
      console.info('changing city to unknown');
    }
    if (this.CountryNameKeyId[counCode] == undefined && times < TWO && counName != null && counName != '' && counFilter != 'yes') {
      console.info('No country id found, search in list and retry....');
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${counCode}&_page=1`).subscribe((data: any) => {
        if (data['count'] > 0) {
          data['countries'].forEach(element => {
            let captain_exist = this.CaptCountry.indexOf(element.countryName);
            let captain_exist1 = this.countrySelList.indexOf(element.countryName);
            if (captain_exist == -1) {
              let obj = {};
              obj['countryCode'] = element['countryCode'];
              obj['countryName'] = element['countryName'];
              obj['rowId'] = element['rowId'];
              this.CountryNameKeyId[element.countryCode] = obj;
            }
            if (captain_exist1 == -1) {
              this.countrySelList.push(`${element.countryCode} - ${element.countryName}`);
            }
          });
        }
        this.saveSitesDetails(CmpName, counName, counCode, CityName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, times + 1);
        this.selectedCountry = counName;
        this.tempVarCounList['CmpName'] = CmpName;
        this.tempVarCounList['counName'] = counName;
        this.tempVarCounList['CityName'] = CityName;
        this.tempVarCounList['Postal'] = Postal;
        this.tempVarCounList['CompanayID'] = CompanayID;
        this.tempVarCounList['BvDidforsite'] = BvDidforsite;
        this.tempVarCounList['fromCnS'] = fromCnS;
        this.tempVarCounList['thisBvDdata'] = thisBvDdata;
        this.tempVarCounList['times'] = times;
      });
    } else if (this.CountryNameKeyId[counCode] == undefined && times == TWO && counFilter != 'yes' && this.countrySelList.length > 1) {
      console.info('tempVarCounList', this.tempVarCounList);
      document.getElementById('btnForSelectCountryId').click();
    } else {
      if (counCode == undefined || counCode == null || counCode == '') {
        counCode = 'CC'
      }
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${counCode}&_page=1`).subscribe((data: any) => {
        if (data['count'] > 0) {
          data['countries'].forEach(element => {
            let captain_exist = this.CaptCountry.indexOf(element.countryName);
            if (captain_exist == -1) {
              let obj = {};
              obj['countryCode'] = element['countryCode'];
              obj['countryName'] = element['countryName'];
              obj['rowId'] = element['rowId'];
              this.CountryNameKeyId[element.countryCode] = obj;
            }
          })
        }
        let countryId;
        let countryCode;
        let cntryName;
        if (counFilter == 'yes') {
          countryId = this.CountryNameKeyId[counCode]['rowId'];
          countryCode = this.CountryNameKeyId[counCode]['countryCode'];
          cntryName = this.CountryNameKeyId[counCode]['countryName'];
          this.selectedCountry = cntryName;
        } else {
          countryId = this.CountryNameKeyId[counCode]['rowId'];
          countryCode = this.CountryNameKeyId[counCode]['countryCode'];
          cntryName = this.CountryNameKeyId[counCode]['countryName'];
          this.selectedCountry = cntryName;
        }

        const cityS = thisBvDdata ? (thisBvDdata['CITY_STANDARDIZED'] ?? '') : '';
        const cityParam = thisBvDdata ? (thisBvDdata['CITY'] ?? CityName) : CityName;
        this.apiService.cityCreationOptimization(cityS, cityParam, counCode,countryId).subscribe((cityObj: any) => {
          const resolvedCityName = cityObj?.name ?? CityName;
          const cityId = cityObj?.rowId;
          if (cityId) {
            this.saveSiteInformation(countryId, cityId, CmpName, resolvedCityName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata);
          }
        });
      })
    }

  }

  saveSiteInformation(countryId, cityId, CmpName: string, CityName: string, Postal = '', CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = []) {
    console.info("thisBvDdata2", thisBvDdata);
    this.SiteRowID = "";
    const siteDatas = {
      cityId: cityId,
      countryId: countryId,
      activeStatus: "CREATED",
      name: `${CmpName} ${CityName}`,
      usualName: `${this.cmpShortName} ${CityName}`,
      effectiveDate: this.apiService.getTodayDate(),
      "irnAuthor": "IRN-71016",
      "siaAuthor": "IAF",
      "isMergingSite": this.varIsMergingSite,
    };
    this.siteService.createSite(`${this.Config.ApiSitesUrl}sites`, siteDatas).subscribe((dataSite: any) => {
      var site_row_id = dataSite["rowId"];
      if (dataSite['identifier']) {
        this.SitesInfo['identifier'] = dataSite['identifier'];
      }
      const constSiteStatus = { "activeStatus": "CREATED" }
      this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${site_row_id}`, constSiteStatus).subscribe(() => {

      }, error => {
        console.error('[BVD IMPORT] Failed to force site status to CREATED for site:', site_row_id, error);
      });
      console.info(`Created New site ID is : ${dataSite["rowId"]}`);
      if (this.NL_Case_Occur == SEVEN || fromCnS == "S" || fromCnS == 'W' || fromCnS == 'Y') {
        this.SiteRowID = dataSite["rowId"];
      }
      const accessPDatas = {
        activeStatus: "ACTIVE",
        realEstateAssetId: site_row_id,
        type: "P14",
        activity: 'A10',
        label: CmpName,
        effectiveDate: this.apiService.getTodayDate(),
        "irnAuthor": "IRN-71016",
        "siaAuthor": "IAF"
      };
      this.groupCurrentStatus = 'Creating Access Points';
      this.nextBtnNotVisible = true;
      this.siteService.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, accessPDatas).subscribe((dataAccessP: any) => {
        let access_point_row_id = dataAccessP["rowId"];
        let addinfo = "";
        if (thisBvDdata['ADDRESS_LINE1'] == undefined || thisBvDdata['ADDRESS_LINE1'] == '' || thisBvDdata['ADDRESS_LINE1'] == null) {
          thisBvDdata['ADDRESS_LINE1'] = 'UNKNOWN';
          console.info('street is null changing to unknown');
        }
        console.info("ADDRESS_LINE1", thisBvDdata['ADDRESS_LINE1']);
        thisBvDdata['ADDRESS_LINE1'] = thisBvDdata['ADDRESS_LINE1'].substring(0, THIRTY_FIVE);
        if (thisBvDdata['ADDRESS_LINE2'] != null && thisBvDdata['ADDRESS_LINE2'] != "") {
          addinfo += `${thisBvDdata['ADDRESS_LINE2']} `;
        }
        if (thisBvDdata['ADDRESS_LINE3'] != null && thisBvDdata['ADDRESS_LINE2'] != "") {
          addinfo += thisBvDdata['ADDRESS_LINE3'];
        }
        let geoADatas = {};
        if (thisBvDdata['ADDRESS_LINE1'] == null) {
          thisBvDdata['ADDRESS_LINE1'] = "";
        }
        addinfo = addinfo.substring(0, ONE_HUNDRED_SEVEN);
        if (Postal != '' && Postal != null) {
          Postal = Postal.substring(0, NINE);
          geoADatas = {
            additionalInformation: addinfo,
            streetName: thisBvDdata['ADDRESS_LINE1'],
            postalCode: Postal,
            cityId: cityId,
            countryId: countryId,
            "irnAuthor": "IRN-71016",
            "siaAuthor": "IAF"
          };
        } else {
          geoADatas = {
            additionalInformation: addinfo,
            streetName: thisBvDdata['ADDRESS_LINE1'],
            cityId: cityId,
            countryId: countryId,
            "irnAuthor": "IRN-71016",
            "siaAuthor": "IAF"
          };
        }
        this.groupCurrentStatus = 'Creating Addresses';
        this.nextBtnNotVisible = true;
        this.addressService.createGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses`, geoADatas).subscribe((dataGeoA: any) => {
          var geo_adress_row_id = dataGeoA["rowId"];
          const accessPointDatas = {
            accessPointId: access_point_row_id,
            addressId: geo_adress_row_id
          };
          this.accessPointDatas1 = geo_adress_row_id
          this.siteService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe((_dataAccessPoint: any) => {
            let accessPointDatas
            if (this.c2bName != '' && this.NL_BVD_ID_NUMBER == BvDidforsite) {
              accessPointDatas =
              {
                activeStatus: "PENDING",
                realEstateAssetId: site_row_id,
                type: "P11",
                activity: 'A10',
                label: CmpName,
                effectiveDate: this.apiService.getTodayDate(),
                "irnAuthor": "IRN-71016",
                "siaAuthor": "IAF"
              }
              this.siteService.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, accessPointDatas).subscribe((dataAccessP: any) => {
                let data = {}
                if (dataAccessP['type'] == "P11") {
                  this.siteService.getIdentifierTypes(`${this.Config.ApiSitesUrl}identifier-types?name=AP_C2B_CODE`).subscribe(data1 => {
                    this.siteService.getSourceSystems(`${this.Config.ApiSitesUrl}source-systems?name=C2B`).subscribe(data2 => {
                      data = {
                        "sourceSystemId": data2['source-systems'][0]['rowId'],
                        "siteIdentifier": dataSite['identifier'],
                        "identifierValue": this.c2bName,
                        "identifierId": data1['identifier-types'][0]['rowId'],
                        "sourceSystemName": "C2B",
                        "accessPointRowId": dataAccessP['rowId'],
                        "effectiveDate": this.apiService.getTodayDate(),
                        "accessPointType": "P11",
                        "identifierTypeName": "AP_C2B_CODE"
                      }
                      this.siteService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, data).subscribe(_data => {
                        const accessPointDatas = { accessPointId: dataAccessP['rowId'], addressId: this.accessPointDatas1 };
                        this.siteService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe((_dataAccessPoint: any) => {

                        })
                        if ((thisBvDdata['LATITUDE'] != '' && thisBvDdata['LATITUDE'] != null) || (thisBvDdata['LONGITUDE'] != '' && thisBvDdata['LONGITUDE'] != null)) {
                          const accessPointDatas2 = {
                            accessPointId: dataAccessP['rowId'],
                            addressId: this.accessPointDatas3
                          };
                          this.siteService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas2).subscribe((_dataAccessPoint: any) => {

                          });
                        }
                      })
                    })
                  })
                }
              })
            }
          });

          if ((thisBvDdata['LATITUDE'] != '' && thisBvDdata['LATITUDE'] != null) || (thisBvDdata['LONGITUDE'] != '' && thisBvDdata['LONGITUDE'] != null)) {
            const gpsDatas = { 'accessPointId': access_point_row_id, 'latitude': thisBvDdata['LATITUDE'] ? thisBvDdata['LATITUDE'].toString() : "", 'longitude': thisBvDdata['LONGITUDE'] ? thisBvDdata['LONGITUDE'].toString() : "" }
            console.info("gpsDatas", gpsDatas);
            this.addressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`, gpsDatas).subscribe((dataGeoA: any) => {
              console.info("geolocation-coordinates-addresses : ", dataGeoA);
              const accessPointDatas2 = {
                accessPointId: access_point_row_id,
                addressId: dataGeoA['rowId']
              };
              this.accessPointDatas3 = dataGeoA['rowId']
              this.siteService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas2).subscribe((_dataAccessPoint: any) => {

              });
            });
          }
        });
      });
      this.addSiteCategoryToAssignment(site_row_id, CompanayID, BvDidforsite, `${CmpName} ${CityName}`, fromCnS, thisBvDdata);
    });
  }
  addSiteCategoryToAssignment(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS = "N", thisBvDdata: any = null) {
    this.groupCurrentStatus = 'Creating Assignments';
    this.nextBtnNotVisible = true;
    const newCategory = { "realEstateAssetId": site_row_id, "categoryId": this.newCategoryAssignment, "categoryName": this.newCategoryName }
    this.siteService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, newCategory).subscribe(_data012 => {
    });
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${site_row_id}&_page=1&status=VALIDATED`).subscribe(data => {
      if (data['pageCount'] == 1) {
        if (data['site-assignments'][0]['status'] == 'VALIDATED') {
          console.info("SRifalse1");
          this.addTaxIdentifiers(BvDidforsite, site_row_id, thisBvDdata);
        } else {
          console.info("SRitrue1");
          this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS, thisBvDdata);
        }
      } else if (data['pageCount'] > 1) {
        console.info("SRifalse2");
        this.addTaxIdentifiers(BvDidforsite, site_row_id, thisBvDdata);
      } else {
        console.info("SRitrue2");
        this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS, thisBvDdata);
      }
    });
  }

  AllgroupCategories(page = 1, subscribeData = []) {
    this.groupCategories = [];
    this.supplierService.getGroupTypes(`${this.Config.ApiSupplierUrl}group-types?_page=${page}`).subscribe((data2: any) => {
      if (data2['group-types'] && data2['group-types'] != null) {
        data2['group-types'].forEach(element => {
          subscribeData.push(element);
        });
      }
      if (data2['maxPage'] > 1 && data2['maxPage'] != page) {
        this.AllgroupCategories(page + 1, subscribeData);
      } else if (data2['maxPage'] == page) {
        this.groupCategories = subscribeData;
        subscribeData.forEach(element => {
          this.groupCategoriesByKey[element.groupTypeCode] = element.row_id;
        });
        this.setDefaultGroupCategoryForImport();
      }
    });
  }

  private setDefaultGroupCategoryForImport() {
    if (this.GroupSelectDisab || this.groupCategoryModel || !this.groupCategories || this.groupCategories.length === 0) {
      return;
    }

    const externalSupplierCategory = this.groupCategories.find(element =>
      element.groupTypeCode && element.groupTypeCode.toLowerCase() === 'external supplier');

    if (externalSupplierCategory) {
      this.groupCategoryModel = externalSupplierCategory.row_id;
      this.groupCategoryModelError = false;
      return;
    }

    // Keep previous behavior as a fallback when External Supplier is unavailable.
    const bopNbopCategory = this.groupCategories.find((cat: any) => {
            const type = (cat.groupTypeCode ?? '').toLowerCase();
            return type === 'bop/nbop' || type === 'external supplier';
          });
    if (bopNbopCategory) {
      this.groupCategoryModel = bopNbopCategory.row_id;
      this.groupCategoryModelError = false;
    }
  }

  ccbyType(Type, grpID, LoadOff = '') {
    var prospectPwosId = '';
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${grpID}/group-approvals?scopeCode=${Type}&groupPwo.href!=""`).subscribe((data: any) => {
      if (data["group-approvals"] != null && data["group-approvals"].length > 0) {
        console.info('debug1', data['group-approvals']);
        for (let i = 0; i < data['group-approvals'].length; i++) {
          let prospectTypeid = data["group-approvals"][i]['groupPwo'].href.split('/');
          prospectPwosId += `${prospectTypeid[1]},`;
        }
        if (prospectPwosId != '') {
          this.purchasingService.getcommodityPerimeters(`${this.Config.ApiPurchasingUrl}commodity-perimeters?typeCode=Commodity Code&rowId=in(${prospectPwosId.slice(0, -1)})`).subscribe((data1: any) => {
            console.info("this.pagerPanelCurrentPage===>", data1);
            if (data1 && data1 != null) {
              if (Type == "Prospect") {
                var TypeCC = "prospectCC";
              } else if (Type == "In panel") {
                var TypeCC = "panelCC";
              }
              this.GroupBvDdetails[TypeCC] = [];
              if (data1['commodity-perimeters']) {
                data1['commodity-perimeters'].forEach(element => {
                  this.GroupBvDdetails[TypeCC].push(`${element.code} - ${element.label}`);
                });
              }
            }
          });
        }
      }
      if (LoadOff == "loadOff") {
        this.loadingImpsupp = false;
      }
    });
  }

  checkvalidateGroupCategoryField() {
    if (this.groupCategoryModel == '') {
      this.groupCategoryModelError = true;
    } else {
      this.groupCategoryModelError = false;
    }
  }

  enableRadio() {
    this.radioImpSupplier = false;
    this.importNextButt = "Next";
    this.importSuppStep2 = false;
    this.importSuppStep3 = false;
  }

  getCompaniesbyGroupID(GroupId) {
    var curr_page = 1;
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${GroupId}/group-assignments?_page=${curr_page}`).subscribe((data: any) => {
      console.info("Companies", data);
      return data;
    });
  }


  JoinBusniessEntity() {
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${this.beRowID})`).subscribe(
      (data: any) => {
        if (data['business-entity-identifiers'].length > 0) {
          data['business-entity-identifiers'].forEach(element => {
            if (element.businessEntityIdentifierTypeName.toLowerCase() == "bvd id") {
              this.SiteDe_BvdID_Stat[element.businessEntityId] = element;
            }
          });
        }
      });
  }

  joincityCountry() {
    if (this.SiteRowID.length > 0) {
      this.Site_City_Country = [];
      this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?_page=1&rowId=in(${this.SiteRowID})&activeStatus=ACTIVE`).subscribe((data: any) => {
        data['sites'].forEach(element5 => {
          this.Site_City_Country[element5.rowId] = element5;
        });
      });
    }
    this.SiteDispLoading = false;
  }

  JoinQualifiers() {
    if (this.SiteRowID.length > 0) {
      this.site_qualifiers = [];
      this.siteService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${this.SiteRowID})`).subscribe(
        (data: any) => {
          data['access-points'].forEach(element2 => {
            if (typeof this.site_qualifiers[element2.realEstateAssetId] == 'undefined') {
              this.site_qualifiers[element2.realEstateAssetId] = [];
            }
            if (this.site_qualifiers[element2.realEstateAssetId][element2.type]) {
              var ove = this.site_qualifiers[element2.realEstateAssetId][element2.type];
              this.site_qualifiers[element2.realEstateAssetId][element2.type] = ove + 1;
            }
            else {
              this.site_qualifiers[element2.realEstateAssetId][element2.type] = 1;
            }
          });
          this.SiteDispLoading = false;
        });

    } else {
      this.SiteDispLoading = false;
    }
  }


  AllCompanyIdentifierTypes2() {
    this.CIdentifierTypes = [];
    this.CIdentifierTypes[0] = 'Alliance Company ID';
    this.supplierService.getCompanyIdentifierKeys(`${this.Config.ApiSupplierUrl}company-identifier-keys`).subscribe((data: any) => {
      if (data['company-identifier-keys'].length > 0) {
        data['company-identifier-keys'].forEach(element => {
          if (element['name'].toLowerCase() != "duns") {
            this.CIdentifierTypes.push(element['name']);
            this.IdenKeywithId[element['name'].toLowerCase()] = element['row_id'];
          }
        });
      }
      this.loading = false;
    }, _error => {
      this.AllCompanyIdentifierTypes2();
    });
  }
  AllCompanyIdentifierTypes() {
    this.CIdentifierTypes = [];
    this.CIdentifierTypes[0] = 'Alliance Company ID';
    this.supplierService.getCompanyIdentifierKeys(`${this.Config.ApiSupplierUrl}company-identifier-keys`).subscribe((data: any) => {
      if (data['company-identifier-keys'].length > 0) {
        data['company-identifier-keys'].forEach(element => {
          if (element['name'].toLowerCase() != "duns") {
            this.CIdentifierTypes.push(element['name']);
            this.IdenKeywithId[element['name'].toLowerCase()] = element['row_id'];
          }
        });
      }
      this.loading = false;
    }, _error => {
      this.AllCompanyIdentifierTypes();
    });
  }

  getCommodityCodes(codes: any) {
    if (this.tempvar != codes && codes.length > 1) {
      this.commoditycodeloaded = true;
      this.commoditycodeloadedcheck = false;
      this.tempvar = codes;
      this.commodityCodes = [];
      this.supplierCommodityCodes = [];
      this.commodityCodeids = [];
      var cod = codes.split(' - ');
      this.purchasingService.getcommodityPerimeters(`${this.Config.ApiPurchasingUrl}commodity-perimeters?typeCode=Commodity Code&typeScope=BOP&code=*${encodeURI(cod['0'].toLowerCase())}*&_page=1`).subscribe((data: any) => {
        if (data && data != null) {
          let j = 0;
          for (let i = 0; i < data['commodity-perimeters'].length; i++) {
            this.commodityCodes[j] = data['commodity-perimeters'][i];
            this.commodityCodes[j]['code_label'] = `${data['commodity-perimeters'][i]['code']} - ${data['commodity-perimeters'][i]['label']}`;
            this.supplierCommodityCodes[j] = `${data['commodity-perimeters'][i]['code']} - ${data['commodity-perimeters'][i]['label']}`;
            this.commodityCodeids[`${data['commodity-perimeters'][i]['code']} - ${data['commodity-perimeters'][i]['label']}`] = data['commodity-perimeters'][i]['rowId'];
            j++;
          }
          this.commoditycodeloadedcheck = false;
        }
        this.commoditycodevalueSelected = false;
        this.commoditycodeloaded = false;
      }, error => {
        console.info('data_error', error);
      });
    }
    return "ok";
  }

  checkCommodityCodeField() {
    if (this.groupCommodityCodeModelLabel == '') {
    } else {

    }
  }

  setCommodityCodeModel() {
    console.info("this.groupCommodityCodeModelLabel====>", this.groupCommodityCodeModelLabel);
    console.info("this.commodityCodeids====>", this.commodityCodeids);
    this.commoditycodevalueSelected = true;
    if (typeof this.commodityCodeids[this.groupCommodityCodeModelLabel] != 'undefined') {
      this.groupCommodityCodeModel = this.commodityCodeids[this.groupCommodityCodeModelLabel];
      this.commoditycodeloadedcheck = false;
    } else {
      this.groupCommodityCodeModel = '';
      this.commoditycodeloadedcheck = true;
    }
    return false;
  }

  changeCompanySiteAssnNoExist(siteID, CMPiD, BvDidforsite, Site_Name, fromCnS = "N", thisBvDdata: any = null) {
    var tempBusinessRowId;
    this.groupCurrentStatus = 'Creating BvD for Site';
    this.nextBtnNotVisible = true;
    if (fromCnS == "S") {
      const datas2 = { modificationStatus: "VALIDATED", isHQ: "N", companyId: CMPiD };
      this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, datas2).subscribe((dataGApprovals: any) => {
        tempBusinessRowId = dataGApprovals['row_id'];
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
          if (data1['pageCount'] > 0) {

          }
          else {
            const const2 = {
              "businessEntityIdentifierTypeId": "1",
              "businessEntityIdentifierTypeName": "BVD ID",
              "startDate": this.apiService.getTodayDate(),
              "businessEntityId": tempBusinessRowId,
              "value": BvDidforsite
            }
            this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {

            });
          }
          const const3 = {
            "validityStartDate": this.apiService.getTodayDate(),
            "status": "VALIDATED",
            "businessEntityId": tempBusinessRowId
          }
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(data3 => {
            this.businessEntityIdSite = data3.businessEntityId;
            this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS, thisBvDdata);
         
          })
        });
      });
    } else {
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${CMPiD}&isHQ=Y`).subscribe(data => {
        if (data['business-entities'].length > 0) {
          tempBusinessRowId = data['business-entities'][0]['row_id'];
          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
            if (data1['pageCount'] > 0) {

            }
            else {
              const const2 = {
                "businessEntityIdentifierTypeId": "1",
                "businessEntityIdentifierTypeName": "BVD ID",
                "startDate": this.apiService.getTodayDate(),
                "businessEntityId": tempBusinessRowId,
                "value": BvDidforsite
              }
              this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {

              });
            }
            const const3 = {
              "validityStartDate": this.apiService.getTodayDate(),
              "status": "VALIDATED",
              "businessEntityId": tempBusinessRowId
            }
            this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(data3 => {
              this.businessEntityIdSite = data3.businessEntityId;
              this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS, thisBvDdata);
            });
          });
        } else {
          const datas = { companyId: CMPiD, isHQ: "Y" };
          this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, datas).subscribe(data2 => {
            tempBusinessRowId = data2['row_id'];
            this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
              if (data1['pageCount'] > 0) {

              }
              else {
                const const2 = {
                  "businessEntityIdentifierTypeId": "1",
                  "businessEntityIdentifierTypeName": "BVD ID",
                  "startDate": this.apiService.getTodayDate(),
                  "businessEntityId": tempBusinessRowId,
                  "value": BvDidforsite
                }
                this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => { });
              }
              const const3 = {
                "validityStartDate": this.apiService.getTodayDate(),
                "status": "VALIDATED",
                "businessEntityId": tempBusinessRowId
              }
              this.groupCurrentStatus = 'Creating Site Assignment';
              this.nextBtnNotVisible = true;
              this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(data3 => {
                this.businessEntityIdSite = data3.businessEntityId;
                this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS, thisBvDdata);
              });
            });
          });
        }
      });
    }
  }

  changeParamsforNewCpy(_con, site_id, CompanayID, Site_Name, BvDidforsite, fromCnS = "N", thisBvDdata: any = null) {
    this.cpyAlcorToRaft = [];
    this.groupCurrentStatus = 'Creating Raft Account';
    this.nextBtnNotVisible = true;
    if (CompanayID != '' && CompanayID != undefined) {
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${CompanayID}`).subscribe(data1 => {

        const const1 = { "name": Site_Name }
        this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${site_id}`, const1).subscribe(_data0 => {

        });
        let shortName
        this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${CompanayID}`).subscribe(data2 => {
          if (data2['company-names'].length > 0) {
            shortName = data2['company-names'][0]['value'];
          } else {
            shortName = data1['legalName'].slice(0, TEN);
          }
          this.cmpShortName = shortName
          this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=RAFT_ACCOUNT`).subscribe(data6 => {
            if (data6['real-estate-asset-identifiers'].length > 0) {
              const constEndDate = { "endDate": this.apiService.getTodayDate() }
              data6['real-estate-asset-identifiers'].forEach(ele => {
                this.cpyAlcorToRaft.push(ele.businessIdentifierValue);
                this.arrBasedOnVal[ele.businessIdentifierValue] = ele.rowId;
                this.siteService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${ele.rowId}`, constEndDate).subscribe(_data7 => {
                });
              });
            }
            this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${CompanayID}&companyIdentifierKeyName=ALCOR`).subscribe(data8 => {
              if (data8['company-identifiers'].length > 0) {
                let const5;
                if (shortName == '') {
                  shortName = data1['legalName'].slice(0, TEN);
                }
                this.cmpShortName = shortName
                const constNoEndDate = { "endDate": "" }
                data8['company-identifiers'].forEach(elem => {
                  if (this.cpyAlcorToRaft.indexOf(elem.value) == -1) {
                    this.siteService.getIdentifierTypes(`${this.Config.ApiSitesUrl}identifier-types?name=RAFT_ACCOUNT`).subscribe(data1 => {
                    if (elem.endDate == '') {
                      const5 = {
                        "businessIdentifierId": data1['identifier-types'][0]['rowId'],
                        "sourceSystemId": "2",
                        "businessIdentifierValue": elem.value,
                        "effectiveDate": this.apiService.getTodayDate(),
                        "businessIdentifierName": shortName,
                        "realEstateAssetId": site_id
                      }
                    } else {
                      const5 = {
                        "businessIdentifierId": data1['identifier-types'][0]['rowId'],
                        "sourceSystemId": "2",
                        "businessIdentifierValue": elem.value,
                        "effectiveDate": this.apiService.getTodayDate(),
                        "businessIdentifierName": shortName,
                        "realEstateAssetId": site_id,
                        "endDate": elem.endDate
                      }
                    }

                    this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, const5).subscribe(_data9 => {
                    })
                  })
                  } else {
                    if (this.arrBasedOnVal[elem.value]) {
                      this.siteService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${this.arrBasedOnVal[elem.value]}`, constNoEndDate).subscribe(_data10 => {

                      });
                    }
                  }
                });
              }
              this.changeAccessPointsToPending(site_id, CompanayID, BvDidforsite);
              this.addTaxIdentifiers(BvDidforsite, site_id, thisBvDdata);
              console.info("**** Create Site Done ****", fromCnS);
              if (fromCnS == "Y") {
                this.fetchCompanyDetails(BvDidforsite);
                this.groupCurrentStatus = 'Fetching Company Details';
              } else if (fromCnS == "S") {
                this.fetchSiteDetails();
                this.groupCurrentStatus = 'Fetching Site Details';
              } else if (fromCnS == 'W') {
                this.getBvdinterfaceSite(BvDidforsite);
                this.fetchSiteDetails();
                this.groupCurrentStatus = 'Fetching Site Details';
              } else {
                this.fetchGroupDetails(BvDidforsite, "Hide");
                this.groupCurrentStatus = 'Fetching Group Details';
              }

            }, () => {
              this.addTaxIdentifiers(BvDidforsite, site_id, thisBvDdata);
            });
          }, () => {
            this.addTaxIdentifiers(BvDidforsite, site_id, thisBvDdata);
          });

          this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=SHORT_NAME`).subscribe(data3 => {
            if (data3['real-estate-asset-identifiers'].length > 0) {
              let tempShtNameRowId = data3['real-estate-asset-identifiers'][0]['rowId'];
              const const11 = { 'endDate': this.apiService.getTodayDate() }
              this.siteService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${tempShtNameRowId}`, const11).subscribe(_data4 => {

              });
            } else {
            }
          });

        }, () => {
          this.addTaxIdentifiers(BvDidforsite, site_id, thisBvDdata);
        });
        this.changeRealEstateAssignments(site_id, data1['legalName']);
      }, () => {
        this.addTaxIdentifiers(BvDidforsite, site_id, thisBvDdata);
      });

    } else {
      this.addTaxIdentifiers(BvDidforsite, site_id, thisBvDdata);
    }
  }

  changeRealEstateAssignments(site_id, CompNme) {
    this.groupCurrentStatus = 'Update Real Esatate Assignments';
    this.siteService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?realEstateAssetId=${site_id}`).subscribe(data => {
      if (data['real-estate-asset-assignments'].length > 0) {
        let exist: any = false;
        let rowId = '';
        const const1 = { categoryId: this.newCategoryAssignment, categoryName: this.newCategoryName };
        const constEndDate = { "endDate": this.apiService.getTodayDate() };
        let c = 0;
        data['real-estate-asset-assignments'].forEach((element, _index) => {
          if ((element.categoryCode != '') && exist == false && element.legalEntityIdentifier == '') {
            rowId = element.rowId;
            exist = true;
          }
          if (element.legalEntityIdentifier != '' && element.endDate != '') {
            this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${element.rowId}`, constEndDate).subscribe(_data1 => {

            });
          }
          c++;
        });
        if (exist == false) {
          this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${rowId}`, const1).subscribe(_data => {
          });
        }
      }
    });

    const newLegalEntity = { "corporateName": CompNme, "active": '1' }
    this.groupCurrentStatus = 'Creating Legal Entity';
    this.nextBtnNotVisible = true;
    this.siteService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?corporateName=${CompNme}&realEstateAssetId=${site_id}`).subscribe(data014 => {
      let tempRow = '';
      let runLegal = true;
      if (data014['real-estate-asset-assignments'].length > 0) {
        const endDateSet = { endDate: this.apiService.getTodayDate() };
        const noEndD = { endDate: '' }
        for (let i = 0; i < data014['real-estate-asset-assignments'].length; i++) {
          if (data014['real-estate-asset-assignments'][i]['legalEntityIdentifier'] != '' && data014['real-estate-asset-assignments'][i]['endDate'] == '' && data014['real-estate-asset-assignments'][i]['legalEntityCorporateName'] != CompNme) {
            this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${data014['real-estate-asset-assignments'][i]['rowId']}`, endDateSet).subscribe(_data0 => {

            });
          }
          if (data014['real-estate-asset-assignments'][i]['legalEntityCorporateName'] == CompNme) {
            tempRow = data014['real-estate-asset-assignments'][i]['legalEntityId'];
            runLegal = false;
            if (data014['real-estate-asset-assignments'][i]['endDate'] != '') {
              this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${data014['real-estate-asset-assignments'][i]['rowId']}`, noEndD).subscribe(_data0 => {
              });
            }

          }
        }
      }
      if (runLegal == true) {
        this.siteService.createLegalEntity(`${this.Config.ApiSitesUrl}legal-entities`, newLegalEntity).subscribe(data013 => {
          const newLegalPost = { 'realEstateAssetId': site_id, 'legalEntityId': data013['rowId'] }
          this.siteService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, newLegalPost).subscribe(_data015 => {

          });
        });
      }
    });
  }

  changeAccessPointsToPending(site_id, _CompanayID, _BvDidforsite) {
    this.groupCurrentStatus = 'Changing Access Point status';
    this.siteService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${site_id})&_page=1`).subscribe(data => {
      var sitesData = data['access-points'];
      if (sitesData.length > 0) {
        const constPending = { "activeStatus": "PENDING" }
        const constActive = { "activeStatus": "ACTIVE" }
        const constEndDate = { "endDate": this.apiService.getTodayDate() }
        let OrderManuInvoi = ['P05', 'P06', 'P11'];
        data['access-points'].forEach(element => {
          if (this.qualifierChangetoPending.indexOf(element.type) != -1) {
            if (element.activeStatus != 'PENDING') {
              if (element.activeStatus == 'ARCHIVED') {
                this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constActive).subscribe(_data0 => {
                  this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data11 => {
                  });
                });
              } else {
                this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data1 => {

                });
              }
            }

            if (OrderManuInvoi.indexOf(element.type) != -1 && element.identifier) {
              this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?accessPointIdentifier=${element.identifier}`).subscribe(getdata12 => {
                if (getdata12["access-point-identifiers"].length > 0) {
                  if (getdata12["access-point-identifiers"][0].identifierTypeName != 'AP_C2B_CODE') {
                    this.siteService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${getdata12["access-point-identifiers"][0].rowId}`, constEndDate).subscribe(_data12 => {
                    });
                  }
                }
              })
            }
          }
        });
      }
    });

  }
  checkvalidateGroupShortNameField(event) {
    this.groupShortName = event.toUpperCase();
    let regEx = new RegExp('^[a-zA-Z0-9]+$');
    if (this.groupShortName.trim() == '') {
      this.groupShortNameError = true;
      this.groupShortNameRegExError = false;
    } else {
      if (regEx.test(this.groupShortName)) {
        this.groupShortNameRegExError = false;
      } else {
        this.groupShortNameRegExError = true;
      }
      this.groupShortNameError = false;
    }
  }
  updateCreateGroupExistsName() {
    this.groupNameModel = '';
    this.groupCategoryModel = '';
    this.groupCommodityCodeModel = '';
    this.groupShortName = '';
    this.groupNameModelError = false;
    this.groupShortNameError = false;
    this.groupShortNameRegExError = false;
    this.groupShortNameExistsError = false;
    this.groupCategoryModelError = false;
    this.commodityCodes = [];
    this.supplierCommodityCodes = [];
    this.commodityCodeids = [];
  }

  resetGroupShortNameFields() {
    this.groupShortNameExistsError = false;
    this.groupShortNameRegExError = false;
    this.groupShortName = '';
    this.groupShortNameError = true;
  }

  resetOtherFields(id) {
    if (id == 'name') {
      this.IdentifierModel = '';
      this.siteCountryModelForTaxId = '';
      this.disableIdentifierInput = true;
    } else {
      this.siteCountryModelError = false;
      this.companyNameModel = '';
      this.siteCountryModel = '';
      this.siteCityModel = '';
    }
  }

  redirectToSiteDetails() {
    if (this.GroupBvDdetails['siteAllianceIdentifier'] != '') {
      this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?identifier=${this.GroupBvDdetails['siteAllianceIdentifier']}`).subscribe(data => {
        if (data['sites'].length > 0) {
          let siteId = data['sites'][0]['rowId'];
          this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteId}`).subscribe(data1 => {
            if (data1['site-assignments'].length > 0) {
              let companyId = data1['site-assignments'][0]['businessEntityCompanyId'];
              setTimeout(function () {
                document.getElementById('closeCCBtn').click();
                this.router.navigate(['/site-details', siteId, companyId]);
              }.bind(this), SHORT_DELAY_MS)
            }
          })
        }
      });
    }
  }

  redirectToCompanyDetails() {
    if (this.latestCompanyId != '') {
      setTimeout(function () {
        document.getElementById('closeCCBtn').click();
        this.router.navigate(['/company-details', this.latestCompanyId]);
      }.bind(this), SHORT_DELAY_MS)
    }
  }

  identifierValueChange(event) {
    console.info('identifierValueChange called with event:', event);
    const selectedValue = event.value || event.target?.value || this.selectedIdentifierType;
    console.info('selectedValue:', selectedValue);

    if (selectedValue == 'taxid') {
      console.info('Setting showCountrySelectForTaxId to true');
      this.showCountrySelectForTaxId = true;
      this.disableIdentifierInput = true;
      this.IdentifierModel = '';
      this.cdr.detectChanges();
    } else {
      console.info('Setting showCountrySelectForTaxId to false');
      this.IdentifierModel = '';
      this.showCountrySelectForTaxId = false;
      this.disableIdentifierInput = false;
      this.cdr.detectChanges();
    }
  }

  onIdentifierTypeModelChange(value: string) {
    console.info('onIdentifierTypeModelChange called with value:', value);

    if (value == 'taxid') {
      console.info('Setting showCountrySelectForTaxId to true (ngModelChange)');
      this.showCountrySelectForTaxId = true;
      this.disableIdentifierInput = true;
      this.IdentifierModel = '';
    } else {
      console.info('Setting showCountrySelectForTaxId to false (ngModelChange)');
      this.IdentifierModel = '';
      this.showCountrySelectForTaxId = false;
      this.disableIdentifierInput = false;
    }
    this.cdr.detectChanges();
  }

  sendMailFn(mailTo, mailSubject, mailBody) {
    let mailcontent: any = {};
    mailcontent.toAddress = mailTo,
      mailcontent.mailSubject = mailSubject,
      mailcontent.body = mailBody
    let baseUrl1 = baseUrl
    this.http.post(`${baseUrl1}/api/sendMail`, mailcontent).subscribe(data => {
      console.info(data);
    });
  }

  pageHeightStyle() {
    if (this.loadData == true && this.data.length > 0) {
      let myStyleClass = {
        'height': `${this.pageHeight}px`,
        'overflow-y': 'scroll'
      };
      return myStyleClass;
    }
  }

  countryInfoModel(page = 1, subscribeData = []) {
    this.countryInfoLoading = true;
    this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?_page=${page}`).subscribe((data: any) => {
      if (data['countries'].length > 0) {
        data['countries'].forEach(element1 => {
          subscribeData.push(element1);
        });
      }
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.countryInfoModel(page + 1, subscribeData);
      } else if (data['maxPage'] == page) {
        this.dataForDispCountryInfo = [];
        subscribeData.forEach(el => {
          const svg = `${el.countryFlag}`
          svgToPng(svg, (imgData) => {
            const pngImage = document.createElement('img');
            document.body.appendChild(pngImage);
            pngImage.src = imgData;
            document.body.removeChild(pngImage);
          });
          function svgToPng(svg, callback) {
            const url = getSvgUrl(svg);
            svgUrlToPng(url, (imgData) => {
              callback(imgData);
              if (el['flag'] == undefined) {
                el['flag'] = [];
              }
              el['flag'] = imgData;
              URL.revokeObjectURL(url);
            });
          }
          function getSvgUrl(svg) {
            return URL.createObjectURL(new Blob([svg], {
              type: 'image/svg+xml'
            }));
          }
          function svgUrlToPng(svgUrl, callback) {
            const svgImage = document.createElement('img');
            svgImage.onload = () => {
              const canvas = document.createElement('canvas');
              canvas.width = TWENTY_FIVE;
              canvas.height = TWENTY_FIVE;
              const canvasCtx = canvas.getContext('2d');
              canvasCtx.drawImage(svgImage, 0, 0);
              const imgData = canvas.toDataURL('image/png');
              callback(imgData);
            };
            svgImage.src = svgUrl;
          }
          this.dataForDispCountryInfo.push(el);
        });
        this.dataForDispCountryInfo.sort((a, b) => (a.countryCode < b.countryCode ? -1 : 1))
        this.countryInfoLoading = false;
      }
    }, _error => {
      this.countryInfoLoading = false;
    });
  }
  addTaxIdentifiers(sitebvidid, site_id, thisBvDdatatoImport) {
    if (sitebvidid != '') {
      let thisBvDdata = [];
      const bvdConst = { 'bvd-id': sitebvidid, import: "Y" }
      let bVdDatas = thisBvDdatatoImport
      if (bVdDatas != undefined && bVdDatas != null) {
          thisBvDdata = bVdDatas;
          this.currentOrbisStatus=bVdDatas['STATUS'][0]
        }
      console.info('thisbvdData', thisBvDdata);
      console.info('bVdDatas', bVdDatas);
      this.getTaxIdentifiers(site_id);
      let variable = [];
      if (thisBvDdata != undefined) {
        if (bVdDatas['NATIONAL_ID_LABEL'] != null) {
          console.info("bVdDatas['NATIONAL_ID_LABEL']", bVdDatas['NATIONAL_ID_LABEL'])
          if (typeof bVdDatas['NATIONAL_ID_LABEL'] != "string") {
            variable = bVdDatas['NATIONAL_ID_LABEL'].filter(d1 => { return d1 != null });
            bVdDatas['NATIONAL_ID_LABEL'] = variable;
          }
          if (bVdDatas['NATIONAL_ID_LABEL'].length > 0 && bVdDatas['NATIONAL_ID_LABEL'] != null) {
            console.info('yes');
            let nationalIdLabel = [];
            let nationalId = [];
            nationalIdLabel = bVdDatas['NATIONAL_ID_LABEL'];
            nationalId = bVdDatas['NATIONAL_ID'];
            this.manageNewBeIdentifiers(nationalIdLabel, nationalId);
          } else {
            this.newOrbisStatus()
            console.info('%c no tax identifiers', "color : #cb4b32;font-weight:bold")
          }
        } else {
          this.newOrbisStatus()
          console.info('%c no tax identifiers', "color : #cb4b32;font-weight:bold")
        }
      } else {
        this.deleteAllBusinesIdens();
        console.info('%c no tax identifiers', "color : #cb4b32;font-weight:bold")
      }
      console.info("BvDdata", thisBvDdata);
    }
  }

  deleteAllBusinesIdens() {
    this.TaxIdentifierKeys.forEach(e => {
      if (this.companyAliasAll[e]) {
        this.companyAliasAll[e].forEach(ele => {
          this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${ele.key}`).subscribe(_data => {

          });
        });
      }
    });
  }

  getCompanyIdentifierTypes(page = 1, subscribeData = []) {
    this.supplierService.getBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?_page=${page}`).subscribe((data: any) => {
      this.TaxIdentifierKeys = [];
      data['business-entity-identifier-types'].forEach(element => {
        subscribeData.push(element);
      });
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.getCompanyIdentifierTypes(page + 1, subscribeData);
      } else if (data['maxPage'] == page) {
        subscribeData.forEach(element => {
          this.TaxIdentifierKeys.push(element.name);
        });
      }
    });
  }

  getTaxIdentifiers(site_id, bvdf = '') {
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${site_id}&_page=1&status=VALIDATED`).subscribe(data1 => {
      var c = '';
      let count = 0;
      if (data1['pageCount'] == 1) {
        if (data1['site-assignments'][0]['status'] == 'VALIDATED') {
          data1['site-assignments'].forEach(element => {
            if (count == 0) {
              c = element.validityStartDate;
            }
            count++;
            if (c != '' && count > 0) {
              if (c < element.validityStartDate) {
                c = element.validityStartDate
              }
            }
            if (c == element.validityStartDate) {
              bvdf = element.businessEntityId;
              this.businessEntityIdSite = element.businessEntityId;
            }
          });
        }
      }
    });
    this.companyAliasAll = [];
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${bvdf}`).subscribe(data => {
      if (data['business-entity-identifiers'].length > 0) {
        data['business-entity-identifiers'].forEach((e, _index) => {
          if (e.endDate == "" && e.businessEntityIdentifierTypeName != 'BVD ID') {
            let temps = {};
            if (!this.companyAliasAll[e.businessEntityIdentifierTypeName]) {
              this.companyAliasAll[e.businessEntityIdentifierTypeName] = [];
            }
            temps = { 'val': e.value, 'key': e.row_id, 'endDate': e.endDate }
            this.companyAliasAll[e.businessEntityIdentifierTypeName].push(temps);
          }
        });
      }
      this.getCompanyIdentifierTypes();
    });
  }

  newOrbisStatus() {
    this.supplierService.getBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?name=ORBIS-STATUS`).subscribe((dataId: any) => {
      console.info(dataId['business-entity-identifier-types'][0]['row_id'],);
      const const2 = {
        "businessEntityIdentifierTypeId": dataId['business-entity-identifier-types'][0]['row_id'],
        "businessEntityIdentifierTypeName": 'ORBIS-STATUS',
        "startDate": this.apiService.getTodayDate(),
        "businessEntityId": this.businessEntityIdSite,
        "value": this.currentOrbisStatus
      }
      this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data => { })
    })
  }


  manageNewBeIdentifiers(nationalIdLabel, nationalId, allKeyNames = [], allNAKeyNames = [], subscribeData = [], page = 1) {
    this.supplierService.getBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?_page=${page}`).subscribe((data: any) => {
      if (data['business-entity-identifier-types'].length > 0) {
        data['business-entity-identifier-types'].forEach(element => {
          subscribeData.push(element);
          allKeyNames.push(element['name'].toLowerCase())
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.manageNewBeIdentifiers(nationalIdLabel, nationalId, allKeyNames, allNAKeyNames, subscribeData, page + 1);
        } else if (data['maxPage'] == page) {
          subscribeData.forEach(element => {
            this.companyIdenKeys[element['name'].toLowerCase()] = element['row_id'];
          });
          nationalIdLabel.forEach(e => {
            if (allKeyNames.indexOf(e.toLowerCase()) == -1) {
              allNAKeyNames.push(e);
            }
          });
          if (allNAKeyNames.length > 0) {
            this.createNewIdentifiers(allNAKeyNames, nationalIdLabel, nationalId);
          } else {
            this.deletePreviousIdentifiers2(nationalIdLabel, nationalId);
          }
        }
      }
    });
  }

  createNewIdentifiers(allNAKeyNames, nationalIdLabel, nationalId) {
    console.info('allNAKeyNames', allNAKeyNames);
    allNAKeyNames.forEach((e, index) => {
      const createIden = { 'name': e, 'type': 'TAXATION' }
      this.supplierService.createBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types`, createIden).subscribe(_data => {
        if (index + 1 == allNAKeyNames.length) {
          this.manageNewBeIdentifiers(nationalIdLabel, nationalId);
        }
      });
    });
  }

  deletePreviousIdentifiers2(nationalIdLabel, nationalId, subscribeData = [], delBvdIds = [], page = 1) {
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${this.businessEntityIdSite})&_page=${page}`).subscribe(data => {
      if (data['business-entity-identifiers'].length > 0) {
        data['business-entity-identifiers'].forEach(e => {
          if (e.businessEntityIdentifierTypeName != 'BVD ID') {
            delBvdIds.push(e.row_id);
          }
        });
      }
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.deletePreviousIdentifiers2(nationalIdLabel, nationalId, subscribeData, delBvdIds, page + 1);
      } else if (data['maxPage'] == page) {
        if (delBvdIds.length > 0) {
          delBvdIds.forEach((e, index) => {
            this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${e}`).subscribe(_data => {
              if (index + 1 == delBvdIds.length) {
                this.postNewBeIdentifiers(nationalIdLabel, nationalId);
              }
            });
          });
        } else {
          this.postNewBeIdentifiers(nationalIdLabel, nationalId);
        }
      }
    });
  }

  postNewBeIdentifiers(nationalIdLabel, nationalId) {
    for (let i = 0; i < nationalIdLabel.length; i++) {
    if(nationalId[i]!=null){
      const const2 = {
        "businessEntityIdentifierTypeId": this.companyIdenKeys[nationalIdLabel[i].toLowerCase()],
        "businessEntityIdentifierTypeName": nationalIdLabel[i],
        "startDate": this.apiService.getTodayDate(),
        "businessEntityId": this.businessEntityIdSite,
        "value": nationalId[i]
      }
      this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data => {
        if (i + 1 == nationalIdLabel.length) {
          this.companyAliasAll = [];
        }
      }, _error => {
        if (i + 1 == nationalIdLabel.length) {
          this.companyAliasAll = [];
        }
      });
    }
      if (i == (nationalIdLabel.length - 1)) {
        this.newOrbisStatus();
      }
    }
  }
  toggleMdmCode(_event) {
    this.groupMdmSwitch = !this.groupMdmSwitch
    console.info(this.groupMdmSwitch)
  }
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getColorForStatus(status: string): string {
    if (!status) return '#B7783C';
    if (status[0].toLowerCase() == 'active') {
      return '#5CBA63'
    }
    else if (status[0].toLowerCase() == 'status unknown') {
      return '#FFBD69'
    }
    else {
      const statusLower = status[0].toLowerCase();
      const firstWord = statusLower.split(' ')[0];

      const colorMap = {
        'active': '#FFBD69',
        'inactive': '#FFBD69',
        'administratively': '#FFBD69',
        'in': '#CB4B32',
        'dissolved': '#CB4B32',
        'bankruptcy': '#CB4B32'
      };

      return colorMap[firstWord] || '#B7783C';
    }
  }
}
